// Helpers from the original theme's custom.js, which this layout no longer loads.
// Defined only when missing, so later code that wraps selects and adds panel close links does not crash.
window.wrap = window.wrap || function (el, wrapper, className) { el.parentNode.insertBefore(wrapper, el); if (className) { wrapper.classList.add(className); } wrapper.appendChild(el); };
window.randomize = window.randomize || function (el) { el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1); };
// The old theme's lazy stylesheets (async.css, async-hovers.css, async-menu.css) were never loaded under the rebuilt
// layout because this helper was missing. Kept as a no-op so the current look stays exactly as designed.
window.new_css = window.new_css || function () {};
// Event objects the old custom.js declared; code below dispatches them.
['listCollectionSlider', 'announcementSlider', 'moduleFeaturedSlider', 'listProductSlider', 'listUspSlider', 'listTestimonialsSlider', 'listStaticSlider', 'searchClasses', 'createCols', 'moduleTabs', 'formZindex', 'ratings', 'inputPadding', 'checkLogoHeight', 'background'].forEach(function (n) { if (!window[n + 'Evt']) { window[n + 'Evt'] = new CustomEvent(n); } });
window.append_url = window.append_url || function (el, content, className, href, access) { var link = document.createElement('a'); if (className) { link.classList.add(className); } link.href = href || './'; if (access === true) { link.setAttribute('tabindex', -1); link.setAttribute('aria-hidden', true); link.setAttribute('focusable', false); } link.innerHTML += content; el.appendChild(link); };

/* -------------------------------------------

	Name:		Theme+
	Date:		2021/11/01

---------------------------------------------  */
/*global document, createElementWithClass, Validator, window, append_url, Cookies, BVSelect, wrap, openPopup, setTimeout, semanticTabs, toggle_dropdowns_simple, noUiSlider, Masonry, simplyCountdown, Fancybox, CountUp, new_css, close_dropdown, enquire,navigator, Promise, IntersectionObserver, Event , console, FormData, DOMParser, fetch, CustomEvent, yall, routes, randomize, handleCookieAccept, handleCookieDecline, whatInput */

//document.addEventListener('DOMContentLoaded', function () {

var html_tag = document.documentElement,
	body_tag = document.getElementsByTagName('body')[0],
	footer_id = document.getElementById('shopify-section-footer'),
	nav_id = document.getElementById('nav'),
	nav_bar_id = document.getElementById('nav-bar'),
	nav_user_id = document.getElementById('nav-user'),
	nav_top_id = document.getElementById('nav-top'),
	header_id = document.getElementById('shopify-section-header'),
	header_main = document.getElementById('header'),
	header_outer = document.getElementById('header-outer'),
	search_id = document.getElementById('search'),
	search_input,
	root_id = document.getElementById('root'),
	top_bar = document.getElementById('shopify-section-announcement-bar'),
	all_list_drop = document.querySelectorAll('.l4dr'),
	ne = document.querySelectorAll('a[aria-controls="nav"]'),
	evt,
	global_dir,
	readMoreText = 'Read more',
	unavailableText = 'Unavailable',
	changeEvent = new Event('change'),
	navEvt = new CustomEvent("nav"),
	navtopEvt = new CustomEvent("navTop"),
	stickyNavEvt = new CustomEvent("stickyNav"),
	searchEvt = new CustomEvent("search"),
	semanticInputEvt = new CustomEvent("semanticInput"),
	semanticSelectEvt = new CustomEvent("semanticSelect"),
	fancyboxEvt = new CustomEvent("fancybox"),
	productVariantsEvt = new CustomEvent("productVariants"),
	productOptionsEvt = new CustomEvent("productOptions"),
	sellingplansEvt = new CustomEvent("sellingplans"),
	pickupAvailabilityEvt = new CustomEvent("pickupAvailability"),
	productBuybarBtnEvt = new CustomEvent("productBuybarBtn"),
	recommendedProductsEvt = new CustomEvent("recommendedProducts"),
	recentlyViewedProductsEvt = new CustomEvent("recentlyViewedProducts"),
	modulePanelEvt = new CustomEvent("modulePanel"),
	modulePanelAnchorEvt = new CustomEvent("modulePanelAnchor"),
	accordeonEvt = new CustomEvent("accordeon"),
	alertsEvt = new CustomEvent("alerts"),
	ratingsEvt = new CustomEvent("ratings"),
	lazyloadAgainEvt = new CustomEvent("lazyloadAgain"),
	mainProductSlideToEvt = new CustomEvent("mainProductSlideTo"),
	moduleFeaturedSlideToEvt = new CustomEvent("moduleFeaturedSlideTo"),
	listCollectionSliderUpdateEvt = new CustomEvent("listCollectionSliderUpdate"),
	showHideDataElementEvt = new CustomEvent("showHideDataElement"),
	listDropEvt = new CustomEvent("listDrop"),
	rangeSliderEvt = new CustomEvent("rangeSlider"),
	masonryEvt = new CustomEvent("masonry"),
	countdownEvt = new CustomEvent("countdown"),
	collectionSortEvt = new CustomEvent("collectionSort"),
	initFiltersEvt = new CustomEvent("initFilters"),
	gridListSwitchEvt = new CustomEvent("gridListSwitch"),
	mobileFiltersEvt = new CustomEvent("mobileFilters"),
	tooltipEvt = new CustomEvent("tooltip"),
	updateSlidersEvt = new CustomEvent("updateSliders"),
	popupsEvt = new CustomEvent("popups"),
	announcementEvt = new CustomEvent("announcement");

if (search_id) {
	search_input = search_id.querySelectorAll('input');
}

// Get direction
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}

function loadRes(u, c, i) {
	'use strict';
	if (html_tag.classList.contains(i)) {
		c();
		return true;
	}
	var s = document.createElement('script');
	s.src = u;
	s.async = true;
	s.onload = c;
	document.body.appendChild(s);
	if (!html_tag.classList.contains(i)) {
		html_tag.classList.add(i);
	}
	return true;
}

function close_dropdown(element) {
	'use strict';
	html_tag.classList.remove('user-form-active');
	if (element.classList.contains('toggle') && !element.classList.contains('mtoggle')) {
		element.classList.remove('toggle');
		element.setAttribute('aria-expanded', false);
		return true;
	}
	return false;
}

function siblings(el) {
	'use strict';
	if (el.parentNode === null) {
		return [];
	}

	return Array.prototype.filter.call(el.parentNode.children, function (child) {
		return child !== el;
	});
}
// assign multiple attributes
/*function setAttributes(el, attrs) {
	'use strict';
	for (var key in attrs) {
		el.setAttribute(key, attrs[key]);
	}
}*/

function close_mobile_nav() {
	'use strict';
	html_tag.classList.remove('m2a', 'nav-hover');
	Array.from(document.querySelectorAll('a[aria-controls="nav"]')).forEach(function (el) {
		el.setAttribute('aria-expanded', false);
	});
	enquire.register('screen and (max-width: 1000px)', function () {
		Array.from(document.getElementById('nav').querySelectorAll('a')).forEach(function (el) {
			el.setAttribute('tabindex', -1);
		});
	});
}

function remove_active_submenus(el) {
	'use strict';
	Array.from(el).forEach(function (el) {
		if (el.parentElement.classList.contains('toggle')) {
			el.parentElement.classList.remove('toggle');
			el.parentElement.setAttribute('aria-expanded', false);
		}
	});
}

function clear_mobile_nav() {
	if (nav_top_id) {
		remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
	}
	if (nav_user_id) {
		remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
	}
	if (nav_bar_id) {
		remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
	}
	if (nav_id) {
		setTimeout(function () {
			/*if (nav_id) {
				remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
			}*/
			Array.from(nav_id.querySelectorAll('a.toggle')).forEach(function (el) {
				if (el.parentElement.classList.contains('toggle')) {
					el.parentElement.classList.remove('toggle');
				}
			});
			if (nav_id.hasAttribute('data-type')) {
				nav_id.removeAttribute('data-type');
			}
			Array.from(nav_id.querySelectorAll('li.mtoggle')).forEach(function (el) {
				el.classList.remove('mtoggle');
			});
			Array.from(nav_id.querySelectorAll('ul.ul-toggle')).forEach(function (el) {
				el.classList.remove('ul-toggle');
			});
			Array.from(nav_id.getElementsByClassName('header-before')).forEach(function (el) {
				el.classList.remove('data-title-active');
			});
		}, 400);
	}
}

/*function loadModelViewer() {
	if (!html_tag.classList.contains('model-viewer-loaded')) {
		var model_tag = document.createElement('script');
		model_tag.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.10/model-viewer.js';
		model_tag.setAttribute('type', 'module');
		document.body.appendChild(model_tag);
		html_tag.classList.add('model-viewer-loaded');
	}
}*/

function toggle_dropdowns(el, selector) {
	'use strict';
	var j = document.querySelectorAll(selector),
		i;
	html_tag.classList.remove('user-form-active');
	if (el.parentElement.classList.contains('toggle')) {
		el.parentElement.classList.remove('toggle');
		el.parentElement.setAttribute('aria-expanded', false);
		if (el.parentNode.classList.contains('has-form')) {
			html_tag.classList.remove('user-form-active');
		}
	} else {
		//for (i = 0; i < j.length; i++) {
		/*for (i = 0; i < j.length; i = i + 1) {
			Array.from(j[i].querySelectorAll('li.toggle')).forEach(function (em) {
				em.classList.remove('toggle');
			});
		}*/
		if (selector !== undefined) {
			Array.from(document.querySelectorAll(selector + ' li.toggle')).forEach(function (em) {
				em.classList.remove('toggle');
			});
		}
		if (el.parentNode.classList.contains('has-form')) {
			setTimeout(function () {
				html_tag.classList.add('user-form-active');
			}, 0);
		}
		Array.from(el.closest('ul').children).forEach(function (el) {
			el.classList.remove('toggle');
		});
		el.parentElement.classList.add('toggle');
		el.parentElement.setAttribute('aria-expanded', true);
		el.parentElement.focus(); // this will avoid page scroll down when user click with MOUSE on the element and then press space bar to toggle it
	}
}
/**
 * @04
 * This function is super big and it's doing a lot of stuffs! If you start moving around to specific functions some pieces of that code, you'll end up with a smaller function and it will be easier to do future changes
 */

// #nav-top
window.addEventListener("navTop", function(evt) {
	"use strict";
	var nav_id = document.getElementById('nav'),
			nav_user_id = document.getElementById('nav-user'),
			nav_top_id = document.getElementById('nav-top'),
			header_id = document.getElementById('shopify-section-header');
	if (nav_top_id) {
		// Handle #nav-top submenus
		Array.from(nav_top_id.querySelectorAll('a.toggle')).forEach(function (el) {

			function click_handler(el) {
				// "use strict";
				close_mobile_nav();
				if (nav_id) {
					remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
				}
				if (nav_user_id) {
					remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
				}
				toggle_dropdowns(el);
			}
			el.addEventListener('click', function (e) {
				click_handler(el);
				e.preventDefault();
			});
			el.addEventListener('keyup', function (e) {
				if (e.key === ' ') {
					click_handler(el);
					e.preventDefault();
				}
			});
			if (el.nextElementSibling !== null) {
				el.nextElementSibling.addEventListener('mouseleave', function () {
					close_dropdown(el.parentElement);
				});
			}
		});

		// If #nav exists, create a #nav-top for mobile menu
		if (nav_id) {
			Array.from(nav_top_id.querySelectorAll('ul[data-type]')).forEach(function (el) {
				var clone_me = el.cloneNode(true);
				clone_me.classList.add('nav-top');
				nav_id.appendChild(clone_me);
			});
		}
		if (!html_tag.classList.contains('t1nt')) {
			html_tag.classList.remove('t1nt');
		}
	} else {
		if (!html_tag.classList.contains('t1nt')) {
			html_tag.classList.add('t1nt');
		}
	}
});
window.dispatchEvent(navtopEvt);

// #nav-bar
function nav_burger() {
	"use strict";
	html_tag.classList.add('has-nav');
	Array.from(nav_id.querySelectorAll('a.toggle')).forEach(function (el) {
		el.parentElement.classList.remove('toggle');
	});
	if (nav_top_id) {
		remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
	}
	if (nav_user_id) {
		remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
	}
	if (nav_bar_id) {
		remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
	}
	html_tag.classList.remove('nav-hover');
	if (html_tag.classList.contains('m2a')) {
		close_mobile_nav();
	} else {
		html_tag.classList.add('m2a');
		html_tag.classList.remove('search-compact-active', 'search-full', 'user-form-active');
		if (search_id) {
			search_id.classList.remove('full', 'has-text');
		}
		nav_id.querySelectorAll('a').item(1).focus();
		//console.log(nav_id.querySelectorAll('a:not(.toggle)')[1]);
		setTimeout(function () {
			nav_id.querySelectorAll('li:not(.nav-bar-element) > a:not(.toggle)')[0].focus();
		}, 100);
		Array.from(ne).forEach(function (el) {
			el.setAttribute('aria-expanded', true);
		});
		enquire.register('screen and (max-width: 1000px)', function () {
			Array.from(nav_id.querySelectorAll('a')).forEach(function (el) {
				el.removeAttribute('tabindex');
			});
		});
		new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
	}
}

function navSubHover(el) {
	var nav_id = document.getElementById('nav');
	"use strict";
	if (el.classList.contains('sub') || el.classList.contains('show-all')) {
		html_tag.classList.add('nav-hover');
	} else {
		html_tag.classList.remove('nav-hover');
	}
	var d = el.dataset.index,
		p = el.closest('ul');
	if (el.classList.contains('sub')) {
		Array.from(nav_id.querySelectorAll('.ul-inner')[0].children).forEach(function (el) {
			//el.parentElement.classList.remove('ul-hover');
			el.classList.remove('hover');
			el.setAttribute('aria-expanded', false);
			if (el.matches('[data-index="' + d + '"]')) {
				el.classList.add('hover');
				setTimeout(function () {
					el.querySelectorAll('ul ul a:not(.toggle)')[0].focus();
				}, 100);
				el.setAttribute('aria-expanded', true);
			}
		});
		Array.from(p.children).forEach(function (el) {
			el.parentElement.parentElement.classList.add('ul-hover');
			el.classList.remove('hover');
			el.setAttribute('aria-expanded', false);
		});
		el.classList.add('hover');
		Array.from(el.children).forEach(function (em) {
			if (em.tagName.toLowerCase() === 'ul') {
				p.parentElement.setAttribute('data-items', em.children.length);
				if (em.parentElement.classList.contains('sub-classic') && em.children.length > 5) {
					p.parentElement.setAttribute('data-items', 1);
				}
			}
		});
		el.setAttribute('aria-expanded', true);
	} else {
		Array.from(p.children).forEach(function (el) {
			el.removeAttribute('aria-expanded', false);
		});
	}
}

window.addEventListener("nav", function(evt) {
	var nav_id = document.getElementById('nav'),
		nav_bar_id = document.getElementById('nav-bar'),
		nav_user_id = document.getElementById('nav-user'),
		nav_top_id = document.getElementById('nav-top'),
		header_id = document.getElementById('shopify-section-header'),
		root_id = document.getElementById('root'),
		all_list_drop = document.querySelectorAll('.l4dr'),
		dt,
		ne = document.querySelectorAll('a[aria-controls="nav"]'),
		nav_bar_li,
		nav_id_ul,
		nav_id_btn,
		nav_id_sub_cont,
		na,
		nb,
		nc,
		nd,
		ng,
		s,
		t,
		nf,
		ni,
		nj = document.querySelectorAll('#nav > ul[data-type="main-nav"] > li > ul');

	/*if(nav_bar_id || nav_id){
		append_url(root_id, 'Close', 'overlay-content');
	}*/
	if (nav_id) {
		nav_id.addEventListener('mouseover', function () {
			new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
		});
	}
	if (header_id) {
		Array.from(header_id.querySelectorAll('a.toggle')).forEach(function (el) {
			el.addEventListener('click', function () {
				new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
			});
		});
	}
	if (nav_bar_id || nav_id ) {
		html_tag.classList.remove('t1mn');
	} else {
		html_tag.classList.add('t1mn');
	}
	if (document.querySelector('.has-menu-bar')) {
		html_tag.classList.remove('t1nn');
	} else {
		html_tag.classList.add('t1nn');
	}

	if (nav_bar_id) {
		nav_bar_id.addEventListener('mouseover', function () {
			new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
		});
		append_url(nav_bar_id.children[0], 'Close', 'close');
		Array.from(nav_bar_id.querySelectorAll('a.toggle')).forEach(function (el) {
			el.parentElement.classList.add('sub');

			function click_handler(el) {
				close_mobile_nav();
				if (nav_id) {
					remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
				}
				if (nav_top_id) {
					remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
				}
				if (nav_user_id) {
					remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
				}
				toggle_dropdowns(el);
				if (nav_bar_id.querySelectorAll('[data-type="horizontal-nav"] > li.sub.toggle').length) {
					html_tag.classList.add('nav-hover');
				} else {
					html_tag.classList.remove('nav-hover');
				}
			};
			el.addEventListener('click', function (e) {
				click_handler(el);
				e.preventDefault();
			});
			el.addEventListener('keyup', function (e) {
				if (e.key === ' ') {
					click_handler(el);
					e.preventDefault();
				}
			});
		});

		// If #nav exists, create a #nav-bar for mobile menu
		if (nav_id) {
			var nav_bar_li = [],
				nav_id_ul = document.querySelectorAll('#nav > ul'),
				nav_id_btn = document.querySelectorAll('#header > .link-btn a, #header-inner > .link-btn a');
				nav_id_sub_cont = document.createElement('li');
			Array.from(document.querySelectorAll('#nav-bar > ul > li')).forEach(function (el) {
				el.addEventListener('mouseover', function () {
					html_tag.classList.remove('m2a');
				});
				if (el.classList.contains('collapse-item')) {
					Array.from(el.querySelectorAll(':scope > ul > li > ul > li')).forEach(function (el) {
						var clone_me = el.cloneNode(true);
						clone_me.classList.add('nav-bar-element');
						nav_bar_li.push(clone_me);
					});
				} else {
					var clone_me = el.cloneNode(true);
					clone_me.classList.add('nav-bar-element');
					nav_bar_li.push(clone_me);
				}

			});
			if(nav_id_btn.length){
				nav_id_sub_cont.classList.add('nav-bar-element', 'nav-bar-element-main');
				nav_id_sub_cont.innerHTML = '<a href="./" class="toggle-wide"><span>' + nav_id_btn[0].textContent + '</span> <span class="hidden">alle</span></a> <ul></ul>';
				if (nav_id_btn[0].classList.contains('mobile-hide')) {
					nav_id_sub_cont.classList.add('mobile-hide');
				}
				if(nav_bar_id.hasAttribute('aria-label')){
					Array.from(nav_id_sub_cont.querySelectorAll('span.hidden')).forEach(function (el) {
						el.innerHTML = nav_bar_id.getAttribute('aria-label');
					});
				}
				nav_id_ul[0].prepend(nav_id_sub_cont);
				nav_bar_li.forEach(function (el) {
					nav_id_ul[0].appendChild(el)
				});
				html_tag.classList.remove('t1nb');
			} else {
				html_tag.classList.add('t1nb');
			}
			//if(nav_bar_id.hasAttribute('aria-label')){
				//nav_id_sub_cont.classList.add('nav-bar-element');
				//nav_id_sub_cont.innerHTML = '<a href="./" class="toggle wide">' + nav_bar_id.getAttribute('aria-label') + '</a> <ul></ul>';
				//nav_id_ul[0].prepend(nav_id_sub_cont);
			//}
		}
		// handle mouseovers
		Array.from(nav_bar_id.children[0].children).forEach(function (el) {
			el.addEventListener('mouseover', function (e) {
				if (el.classList.contains('sub') || el.classList.contains('show-all')) {
					html_tag.classList.add('nav-hover');
				} else {
					html_tag.classList.remove('nav-hover');
				}
			});
			el.addEventListener('mouseleave', function (e) {
				html_tag.classList.remove('nav-hover');
			});
		});
	}

	if (nav_id) {
		var na = document.createElement('ul'),
			nb = document.createElement('a'),
			nc = nav_id.children,
			nd = nc[0].children,
			ng = document.createElement('div');
		// Detect if category images are in use
		//ni = document.querySelectorAll('#header-outer > #header ~ [id*="nav"]:not(#nav-top, #nav-user) > ul:first-child > li > a > img');
		ni = document.querySelectorAll('#nav > ul:first-child > li > a > img, #nav-bar > ul:first-child > li > a > img');
		if (ni.length) {
			Array.from(ni).forEach(function (el) {
				var cl = 'category-img';
				el.closest('[id^="nav"]').classList.add(cl);
				el.closest('ul').classList.add(cl);
			});
 		}

		// Create a back link for mobile menu
		Array.from(document.querySelectorAll('#nav > ul > li > a.toggle')).forEach(function (el) {
			var clone_me = el.cloneNode(true);
			clone_me.classList.add('toggle-back');
			el.parentElement.prepend(clone_me);
			if (!el.parentNode.querySelectorAll('li > ul:first-child').length) {
				el.parentElement.classList.add('sub-classic');
			}
		});
		if (nav_bar_id) {
			Array.from(nav_id.querySelectorAll('a.toggle-wide')).forEach(function (el) {
				el.addEventListener('click', function (e) {
					html_tag.classList.toggle('nav-more-active');
					e.preventDefault();
				});
			});
			/*Array.from(document.querySelectorAll('#nav > ul > li a.toggle-back.wide')).forEach(function (el) {
				el.classList.remove('wide');
				if(nav_bar_id.hasAttribute('aria-label')){
					el.innerHTML = nav_bar_id.getAttribute('aria-label');
				}
			});*/
		}

		// Handle #nav submenus for mobile
		Array.from(nav_id.querySelectorAll('a.toggle')).forEach(function (el) {
			el.parentElement.classList.add('sub');

			function click_handler(el) {
				var mobileHeader = nav_id.getElementsByClassName('header-before')[0];
				if (nav_top_id) {
					remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
				}
				if (nav_bar_id) {
					remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
				}
				if (nav_user_id) {
					remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
				}
				if (el.parentElement.classList.contains('toggle')) {
					el.parentElement.classList.remove('toggle', 'mtoggle');
					el.closest('ul').classList.remove('ul-toggle');
					if (el.parentElement.hasAttribute('data-title')) {
						mobileHeader.classList.remove('data-title-active');
					}
				} else {
					Array.from(el.closest('ul').children).forEach(function (el) {
						el.classList.remove('toggle');
					});
					el.parentElement.classList.add('toggle', 'mtoggle');
					el.closest('ul').classList.add('ul-toggle');
					nav_id.setAttribute('data-type', el.closest('[data-type]').getAttribute('data-type'));
					if (el.parentElement.hasAttribute('data-title')) {
						mobileHeader.innerHTML = el.parentElement.getAttribute('data-title');
						mobileHeader.classList.add('data-title-active');
					}
				}
				if (nav_id.querySelectorAll('.ul-toggle').length === 0) {
					nav_id.removeAttribute('data-type');
				}
				//if (el.parentElement.classList.contains('toggle')) {
				if (nav_id.querySelectorAll('[data-type="main-nav"] > li.sub.toggle').length) {
						html_tag.classList.add('nav-hover');
				} else {
					html_tag.classList.remove('nav-hover');
				}
			}
			el.addEventListener('click', function (e) {
				click_handler(el);
				e.preventDefault();
			});
			el.addEventListener('keyup', function (e) {
				if (e.key === ' ') {
					click_handler(el);
					e.preventDefault();
				}
			});
		});

		Array.from(nd).forEach(function (el, index) {
			el.setAttribute('data-index', nd.length - index);
		});

		na.classList.add('inner', 'ul-inner');
		nb.classList.add('close', 'close-nav');
		//nb.style.height = html_tag.offsetHeight - header_id.offsetHeight + 'px';
		nb.innerHTML += 'Close';
		nb.setAttribute('href', './');
		nav_id.appendChild(na);
		nc[0].appendChild(nb);

		//distance_counter.style.top = le.getBoundingClientRect().top + window.scrollY + sa + 'px';

		Array.from(nd).forEach(function (el) {
			na.appendChild(el.cloneNode(true));
		});
		Array.from(nav_id.querySelectorAll('.close-nav')).forEach(function (el) {
			nav_id.appendChild(el.cloneNode(true));
		});
		var s = nav_id.querySelectorAll('.ul-inner')[0].children,
			t = nav_id.querySelectorAll('.close-nav');
		nav_id.after(t[0].cloneNode(true));

		// #nav hover
		Array.from(nd).forEach(function (el) {
			el.addEventListener('mouseover', function (e) {
				navSubHover(el);
				e.preventDefault();
			});
			el.addEventListener('mouseleave', function (e) {
				html_tag.classList.remove('nav-hover');
			});
			Array.from(el.querySelectorAll('a.toggle:not(.toggle-back)')).forEach(function (em) {
				em.addEventListener('click', function (e) {
					navSubHover(el);
				});
			});
		});
		/*Array.from(nav_id.querySelectorAll('ul.inner li.sub')).forEach(function (el) {
			el.addEventListener('mouseover', function (e) {
				console.log('a');
			});
		});*/
		Array.from(nd).forEach(function (el) {
			el.addEventListener('mouseover', function (e) {
				if (el.classList.contains('sub') || el.classList.contains('show-all')) {
					html_tag.classList.add('nav-hover');
				} else {
					html_tag.classList.remove('nav-hover');
				}
			});
			el.addEventListener('mouseleave', function (e) {
				html_tag.classList.remove('nav-hover');
			});
		});

		na.addEventListener('mouseleave', function () {
			nav_id.classList.remove('ul-hover');
		});

		// #nav submenu
		if (nav_id.hasAttribute('aria-label')) {
			var nf = createElementWithClass('div', 'header');
			nf.innerHTML = nav_id.getAttribute('aria-label');
			nav_id.prepend(nf);
		}
		ng.classList.add('header-before', 'header');
		nav_id.prepend(ng);

		// #nav mobile close
		Array.from(header_id.getElementsByClassName('close-nav')).forEach(function (el) {
			el.addEventListener('click', function (e) {
				clear_mobile_nav();
				close_mobile_nav();
				e.preventDefault();
			});
		});

		// #nav burger
		if (ne) {
			Array.from(ne).forEach(function (el) {
				el.addEventListener('click', function (e) {
					nav_burger();
					e.preventDefault();
				});
				el.addEventListener('keyup', function (e) {
					if (e.key === ' ') {
						nav_burger();
						e.preventDefault();
					}
				});
			});
		}
		if (!html_tag.classList.contains('t1nn')) {
			html_tag.classList.remove('t1nn');
		}
	}

	if (!nav_id && !nav_bar_id) {
		if (!html_tag.classList.contains('t1nn')) {
			html_tag.classList.add('t1nn');
		}
	}

	// .sub-static
	if (header_id) {
		var sub_static = header_id.querySelectorAll('.sub-static li > ul:not(:first-child:last-child)');
		Array.from(sub_static).forEach(function (el) {
			"use strict";
			el.parentElement.addEventListener('mouseenter', function () {
				if (el.parentElement.parentElement.clientHeight < (el.clientHeight + el.parentElement.offsetTop - Math.abs(el.offsetTop))) {
					el.classList.add('rounded');
				}
			});
		});
	}

	function linkSmallPopup(em) {
		"use strict";
		if (em.getElementsByClassName('inner')[0].clientWidth < em.getElementsByClassName('inner-text')[0].clientWidth) {
			em.classList.add('longer');
		} else {
			em.classList.remove('longer');
		}
	}

	if (header_id) {
		var list_usp_header = header_id.getElementsByClassName('l4us');
		if (list_usp_header.length) {
			Array.from(list_usp_header).forEach(function (el, in1) {
				"use strict";
				Array.from(el.querySelectorAll('li, .li')).forEach(function (em, in2) {
					var innerText = em.innerHTML,
						linkable,
						linkedPopup,
						isSwiper;
					em.setAttribute('data-index', 'usp-' + in1 + in2);
					em.innerHTML = '<span class="outer"><span class="inner">' + innerText + '</span> <a href="./" class="linked" data-popup="' + em.getAttribute('data-index') + '">' + readMoreText + '</a> <span class="inner-text">' + innerText + '</span></span>';
					Array.from(el.querySelectorAll('.inner-text a')).forEach(function (en) {
						en.setAttribute('tabindex', '-1');
					});
					em.classList.add('rendered');
					linkSmallPopup(em);
					window.addEventListener('resize', function () {
						linkSmallPopup(em);
					});
					linkedPopup = document.createElement('div');
					linkedPopup.classList.add('popup-a', 'w360');
					linkedPopup.setAttribute('data-title', em.getAttribute('data-index'));
					linkedPopup.innerHTML = '<p>' + innerText + '</p>';
					root_id.appendChild(linkedPopup);
					if (el.classList.contains('slider-single')) {
						isSwiper = el.getElementsByClassName('swiper-outer')[0].swiper;
						if (isSwiper !== undefined) {
							append_url(em.querySelectorAll('.outer')[0], 'Next', 'next-item');
							Array.from(el.getElementsByClassName('next-item')).forEach(function (eo) {
								eo.addEventListener('click', function (e) {
									isSwiper.slideNext();
									e.preventDefault();
								});
							});
						}
					}
				});
			});
		}
	}


	// #nav-user
	if (nav_user_id) {
		// Create a close links for form dropdown (login)
		Array.from(nav_user_id.querySelectorAll('li > form')).forEach(function (el) {
			"use strict";
			el.parentNode.classList.add('has-form');
			el.closest('#nav-user').classList.add('has-form');
			append_url(el, 'Toggle', 'toggle');
			append_url(el.parentElement, 'Toggle', 'toggle');
		});

		// Handle #nav-user submenus
		Array.from(nav_user_id.querySelectorAll('a.toggle')).forEach(function (el) {
			"use strict";

			function click_handler(el) {
				close_mobile_nav();
				if (nav_id) {
					remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
				}
				if (nav_top_id) {
					remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
				}
				if (nav_bar_id) {
					remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
				}
				toggle_dropdowns(el);
			}
			el.addEventListener('click', function (e) {
				click_handler(el);
				e.preventDefault();
			});
			el.addEventListener('keyup', function (e) {
				if (e.key === ' ') {
					click_handler(el);
					e.preventDefault();
				}
			});
			if (el.nextElementSibling !== null && el.nextElementSibling.tagName.toLowerCase() !== 'form') {
				el.nextElementSibling.addEventListener('mouseleave', function () {
					close_dropdown(el.parentElement);
				});
			}
		});

		// If #nav exists, create a #nav-user for mobile menu
		if (nav_id) {
			Array.from(nav_user_id.querySelectorAll('ul[data-type]')).forEach(function (el) {
				"use strict";
				var clone_me = el.cloneNode(true);
				clone_me.classList.add('nav-user');
				nav_id.appendChild(clone_me);
			});
			var nav_user_form = nav_id.getElementsByClassName('user-login')[0];
			if (nav_user_form !== undefined) {
				nav_user_form.remove();
	 		}
		}

		// If #nav & #shopify-section-footer exists, create a contact module for mobile menu
		if (footer_id && nav_id) {
			var f_m6cn = footer_id.getElementsByClassName('m6cn'),
			f_l4sc = footer_id.getElementsByClassName('l4sc'),
				f_lang;

			if (!nav_id.getElementsByClassName('m6cn').length && f_m6cn.length) {
				nav_id.appendChild(f_m6cn[0].cloneNode(true));
			}
			if (!nav_id.getElementsByClassName('l4sc').length && f_l4sc.length) {
				nav_id.appendChild(f_l4sc[0].cloneNode(true));
			}
			Array.from(nav_user_id.querySelectorAll('ul[data-type="user-nav"] li:not(.cart) img')).forEach(function (el) {
				"use strict";
				var clone_me = el.parentNode.cloneNode(true);
				clone_me.classList.add('has-img');
				clone_me.classList.remove('mobile-hide');

				nav_id.appendChild(clone_me);
			});
			f_lang = footer_id.querySelectorAll('li.lang a[aria-controls="nav"], li.currency a[aria-controls="nav"]');
			if (f_lang.length) {
				Array.from(f_lang).forEach(function (el) {
					"use strict";
					el.addEventListener('click', function (e) {
						var nv_cl;
						if (el.closest('li').classList.contains('lang')) {
							nv_cl = nav_id.querySelectorAll('.lang > a.toggle:not(.toggle-back)')[0];
						} else if (el.closest('li').classList.contains('currency')) {
							nv_cl = nav_id.querySelectorAll('.currency > a.toggle:not(.toggle-back)')[0];
						}
						nv_cl.click();
						setTimeout(function () {
							nv_cl.focus();
						}, 100);
						e.preventDefault();
					});
				});
			}
		}
	}

});
window.dispatchEvent(navEvt);

// Mobile nav to be keyboard accessible only on mobile devices
if (nav_id) {
	enquire.register('screen and (max-width: 1000px)', function () {
		"use strict";
		Array.from(nav_id.querySelectorAll('a')).forEach(function (el) {
			el.setAttribute('tabindex', -1);
		});
	}).register('screen and (min-width: 1001px)', function () {
		"use strict";
		Array.from(nav_id.querySelectorAll('a')).forEach(function (el) {
			el.removeAttribute('tabindex');
		});
	});
}


// Remove all dropdowns once clicked on ESC
document.addEventListener('keydown', function (evt) {
	"use strict";
	evt = evt || window.event;
	if (evt.key === 'Escape' || evt.key === 'Esc') {
		close_mobile_nav();
		if (nav_id) {
			remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
		}
		if (nav_top_id) {
			remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
		}
		if (nav_user_id) {
			remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
		}
		if (nav_bar_id) {
			remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
		}
		if (all_list_drop.length > 0) {
			Array.from(all_list_drop).forEach(function (element) {
				//all_list_drop.forEach(element => {
				remove_active_submenus(element.querySelectorAll('a.toggle'));
			});
		}
	}
});

// Add Toggleable functionality to all ".l4dr" elements
//all_list_drop.forEach(element => {
window.addEventListener("listDrop", function(evt) {
	var all_list_drop = document.querySelectorAll('.l4dr');
	Array.from(all_list_drop).forEach(function (element) {
		"use strict";
		Array.from(element.querySelectorAll('a.toggle')).forEach(function (el) {
			function click_handler(el) {
				toggle_dropdowns(el, '.l4dr');
				new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
			}
			el.addEventListener('click', function (e) {
				click_handler(el);
				e.preventDefault();
			});
			el.addEventListener('keyup', function (e) {
				if (e.key === ' ') {
					click_handler(el);
					e.preventDefault();
				}
			});
			el.nextElementSibling.addEventListener('mouseleave', function () {
				// toggle_dropdowns(el);
				close_dropdown(el.parentElement);
			});
		});
	});
});
window.dispatchEvent(listDropEvt);


document.onclick = function (evt) {
	"use strict";
	evt = evt || window.event;
	var clicked_element = evt.target;
	var all_aria_expanded = document.querySelectorAll('[aria-expanded="true"]'),
			el_aria_expanded,
			closest_link;
	// if there's no dropdown open, do nothing
	if (all_aria_expanded.length === 0) {
		return
	}

	// loop through all opened dropdowns and check if click was inside/outside of it to determine if keeps opened or not
	// it will keeps opened only if click in an inside element that's not a children of a clickable link
	for (el_aria_expanded of all_aria_expanded) {
		if (el_aria_expanded === clicked_element) {
			continue;
		}
		// .contains() will check if clicked_element belongs to el_aria_expanded
		// and if belongs to, don't do anything (leave dropdown opened)
		if (el_aria_expanded.contains(clicked_element)) {
			// close dropdown when clicked in any of the links <a> present in dropdown
			closest_link = clicked_element.closest("a:not(.toggle, .show)");
			if (closest_link && closest_link.contains(clicked_element)) {
				close_dropdown(el_aria_expanded);
			}
			continue;
		}

		close_dropdown(el_aria_expanded);
	}
};


/////////////////////////////////////

function aria_hide(el) {
	'use strict';
	el.setAttribute('aria-hidden', true);
	el.setAttribute('focusable', false);
}

function aria_show(el) {
	'use strict';
	el.setAttribute('aria-hidden', false);
	el.setAttribute('focusable', true);
}

function getSiblings(el) {
	'use strict';
	return Array.from(el.parentNode.children).filter(function (sibling) {
		return sibling !== el;
	});
}

// check if string ends with any of array suffixes
function endsWithAny(suffixes, string) {
	'use strict';
	for (let suffix of suffixes) {
		if (string.endsWith(suffix))
			return true;
	}
	return false;
}

// Get direction
/*var global_dir;
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}*/

// function new_css moved to custom.js

// Load some less crucial CSS styles with a delay
function asyncCSS() {
	"use strict";
	new_css('async-css', '//trellisblissindia.com/cdn/shop/t/15/assets/async.css?v=68769032873567110051792476875');
}
/*setTimeout(function () {
	new_css('async-css', '//trellisblissindia.com/cdn/shop/t/15/assets/async.css?v=68769032873567110051792476875');
}, 500);*/
/*html_tag.addEventListener('mouseenter', function () {
	loadHovers();
});*/
if (!window.mobileCheck()) {
	document.addEventListener('mousemove', function () {
		"use strict";
		asyncCSS();
		new_css('hovers-css', '//trellisblissindia.com/cdn/shop/t/15/assets/async-hovers.css?v=129599382144994479051792476870');
	});
}
document.addEventListener('keydown', function () {
	"use strict";
	asyncCSS();
});
document.addEventListener('touchstart', function () {
	"use strict";
	asyncCSS();
});
document.addEventListener('scroll', function () {
	"use strict";
	asyncCSS();
});
/*else {
	new_css('async-css', '//trellisblissindia.com/cdn/shop/t/15/assets/async.css?v=68769032873567110051792476875');
}*/
/*html_tag.addEventListener('mousemove', function () {
	loadHovers();
});*/

// Assign aria elements to the #skip links
var skip_id = document.getElementById('skip');
if (skip_id) {
	if (nav_bar_id) {
		skip_id.querySelectorAll('a[href="#nav"]')[0].setAttribute('href', '#nav-bar');
	}
	Array.from(skip_id.querySelectorAll('a')).forEach(function (el) {
		'use strict';
		el.addEventListener('focus', function () {
			this.setAttribute('aria-hidden', false);
		});
		el.addEventListener('blur', function () {
			this.setAttribute('aria-hidden', true);
		});
	});
}


// Form validation
var form_validate = document.getElementsByClassName('f8vl');

function validate_me(el) {
	"use strict";
  loadRes("//trellisblissindia.com/cdn/shop/t/15/assets/plugin-validator.js?v=94239814214486428141792476930", function () {
		if (typeof Validator === 'function') {
			el.noValidate;
			var validationPlugin = new Validator(el, {
				autoScroll: false,
				showValid: true
			});

			if (!validationPlugin.hasError()) {
				validationPlugin.setSubmitEnabled();
			}
			//console.log(el.handleFormSubmit)
			/*Array.from(el.querySelectorAll('input, textarea')).forEach(function (em) {
				if (em.value == "") {
					em.classList.add('empty');
				} else {
					em.classList.remove('empty');
				}
			});*/
		}
		new_css('form-validation-css', "//trellisblissindia.com/cdn/shop/t/15/assets/async-validation.css?v=59164697892790304421792476874");
	}, 'validator-loaded');

}
function validator_run(el) {
	'use strict';
	var formElement = el,
		el_required = formElement.querySelectorAll('[required]');
	if (el_required.length) {
		Array.from(el_required).forEach(function (en) {
			if (en.value === '' && (en.tagName.toLowerCase() === 'input' || en.tagName.toLowerCase() === 'textarea')) {
				en.classList.add('required-empty');
			}
		});
		if (formElement.querySelectorAll('.required-empty').length) {
			Array.from(formElement.querySelectorAll('button[type="submit"]')).forEach(function (em) {
				em.disabled = true;
			});
		}
	}
	Array.from(formElement.querySelectorAll('p, ul')).forEach(function (em) {
		if (!em.classList.contains('form-group')) {
			em.appendChild(createElementWithClass('span', 'invalid-feedback'));
			em.classList.add('form-group');
			Array.from(em.querySelectorAll('span[class*="size-"] + .invalid-feedback')).forEach(function (en) {
				en.previousElementSibling.before(en);
			});
		}
	});
	if (formElement.hasAttribute('data-hold')) {
		validate_me(formElement);
	}
	Array.from(formElement.querySelectorAll('input, select, textarea, button')).forEach(function (formInputs) {
		formInputs.addEventListener('focus', function () {
			validate_me(formElement);
		});
		formInputs.addEventListener('change', function () {
			validate_me(formElement);
		});
	});
	if (!window.mobileCheck()) {
		formElement.addEventListener('mouseover', function () {
			validate_me(formElement);
		});
		formElement.addEventListener('mouseenter', function () {
			validate_me(formElement);
		});
	}
	if (el.querySelectorAll('footer.hidden').length) {
		el.addEventListener('submit', function (e) {
			el.classList.add('submitted');
			e.preventDefault();
		});
	}
}

if (form_validate.length) {
	Array.from(form_validate).forEach(function (el) {
		"use strict";
		validator_run(el);
	});
}


// Show/hide/toggle [data-element]
window.addEventListener("showHideDataElement", function (evt) {
	var data_show = document.querySelectorAll('a[data-enable], input[data-enable], button[data-enable]'),
		data_hide = document.querySelectorAll('a[data-disable], input[data-disable], button[data-disable]'),
		data_toggle = document.querySelectorAll('a[data-toggle], input[data-toggle], button[data-toggle]');
	if (data_show.length || data_hide.length || data_toggle.length) {
		Array.from(data_show).forEach(function (el) {
			'use strict';
			el.addEventListener('click', function (e) {
				Array.from(document.querySelectorAll('[data-element]')).forEach(function (el) {
					el.classList.add('hidden');
				});
				Array.from(document.querySelectorAll('[data-element="' + el.getAttribute('data-enable') + '"]')).forEach(function (el) {
					el.classList.remove('hidden');
				});
				if (el.tagName.toLowerCase() === 'a') {
					e.preventDefault();
				}
			});
		});
		Array.from(data_hide).forEach(function (el) {
			'use strict';
			el.addEventListener('click', function (e) {
				Array.from(document.querySelectorAll('[data-element="' + el.getAttribute('data-disable') + '"]')).forEach(function (el) {
					el.classList.add('hidden');
				});
				if (el.tagName.toLowerCase() === 'a') {
					e.preventDefault();
				}
			});
		});
		Array.from(data_toggle).forEach(function (el) {
			'use strict';
			el.addEventListener('click', function (e) {
				Array.from(document.querySelectorAll('[data-element="' + el.getAttribute('data-toggle') + '"]')).forEach(function (el) {
					if (el.classList.contains('hidden')) {
						el.classList.remove('hidden');
					} else {
						el.classList.add('hidden');
					}
				});
				if (el.tagName.toLowerCase() === 'a') {
					e.preventDefault();
				}
			});
		});
	}
});
window.dispatchEvent(showHideDataElementEvt);


// Toggle input type
var a_show = document.querySelectorAll('a.show');
if (a_show.length) {
	// renamed i to index. Below you do a for-loop and use the same variable name i. This can be really confusing
	// and, as you assign in the for loop the i variable, this i from the function(el, i) is never used - could be removed from code
	Array.from(a_show).forEach(function (el) {
		'use strict';
		var c = el.children,
			d = el.parentElement.nextElementSibling,
			i,
			all;
		el.parentElement.classList.add('has-show');
		d.addEventListener('keyup', function (e) {
			if (d.value === '') {
				el.parentElement.classList.remove('not-empty');
			} else {
				el.parentElement.classList.add('not-empty');
			}
		});
		el.addEventListener('click', function (e) {
			el.classList.toggle('show-toggle');
			for (i = 0, all = c.length; i < all; i = i + 1) {
				c[i].classList.toggle('hidden');
			}
			if (d.getAttribute('type') === 'password') {
				d.setAttribute('type', 'text');
			} else {
				d.setAttribute('type', 'password');
			}
			e.preventDefault();
		});
	});
}

// +/- input
window.addEventListener("semanticInput", function (evt) {
	"use strict";
	var input_amount = document.querySelectorAll('.input-amount:not(.semantic-input-initialized)');
	if (input_amount.length) {
		Array.from(input_amount).forEach(function (el) {
			el.classList.add('semantic-input-initialized');
			var inc = createElementWithClass('a', 'incr'),
				dec = createElementWithClass('a', 'decr');

			inc.setAttribute('href', './');
			dec.setAttribute('href', './');
			inc.setAttribute('aria-label', 'Increase by 1');
			dec.setAttribute('aria-label', 'Descrease by 1');
			el.innerHTML = '<span class="semantic-amount">' + el.innerHTML + '</span>';

			Array.from(el.children).forEach(function (el) {
				var inp = el.querySelector('input');
				el.appendChild(inc);
				el.appendChild(dec);
				if (parseFloat(inp.value) === 1 || inp.value === '') {
					el.querySelector('.decr').classList.add('disabled');
				}
				if (inp.hasAttribute('max') && inp.value === parseFloat(inp.getAttribute('max'))) {
					el.querySelector('.incr').classList.add('disabled');
				}
			});
			if (el.parentNode.classList.contains('submit')) {
				Array.from(el.parentNode.querySelectorAll('button')).forEach(function (em) {
					if (em.classList.contains('size-m')) {
						el.classList.add('size-m');
					}
					if (em.classList.contains('size-l')) {
						el.classList.add('size-l');
					}
				});
			}
		});
		Array.prototype.slice.call(input_amount).map(function (el) {
			return {
				input: el.querySelector('input'),
				decr: el.querySelector('.decr'),
				incr: el.querySelector('.incr'),
				get value() {
					return parseInt(this.input.value);
				},
				set value(newValue) {
					var input = el.querySelector("input"),
						decrElements,
						incrElements,
						dataLink,
						inputLink,
						decrElementLinkData,
						incrElementLinkData;
					input.value = newValue;

					decrElements = [this.decr]; // if has data-link, it will change decr for data-link element too
					incrElements = [this.incr]; // if has data-link, it will change decr for data-link element too

					// check if input has a data-link attribute. If it has, get element associated with and set new value
					dataLink = input.getAttribute("data-link");
					if (dataLink) {
						inputLink = document.querySelector(dataLink);
						if (inputLink) {
							inputLink.value = newValue;

							decrElementLinkData = inputLink.closest(".input-amount");
							incrElementLinkData = inputLink.closest(".input-amount");
							if (decrElementLinkData) {
								decrElementLinkData = decrElementLinkData.querySelector(".decr");
								decrElements.push(decrElementLinkData);
							}
							if (incrElementLinkData) {
								incrElementLinkData = incrElementLinkData.querySelector(".incr");
								incrElements.push(incrElementLinkData);
							}
						}
					}

					// loop through all decr elements to change its class if needed
					Array.from(decrElements).forEach(function (decrEl) {
						//decrElements.forEach(decrEl => {
						if (parseFloat(newValue) < 2) {
							decrEl.classList.add('disabled');
						} else {
							if (decrEl.classList.contains('disabled')) {
								decrEl.classList.remove('disabled');
							}
						}
					});
					Array.from(incrElements).forEach(function (incrEl) {
						if (input.hasAttribute('max')) {
							if (parseFloat(newValue) === parseFloat(input.getAttribute('max'))) {
								incrEl.classList.add('disabled');
							} else {
								if (incrEl.classList.contains('disabled')) {
									incrEl.classList.remove('disabled');
								}
							}
						}
					});
				}
			};
		}).forEach(function (el) {
			el.decr.addEventListener('click', function (e) {
				if (el.value > 1) {
					el.value -= 1;
				}
				el.input.dispatchEvent(changeEvent);
				e.preventDefault();
			});
			el.incr.addEventListener('click', function (e) {
				if (el.input.hasAttribute('max')) {
					if (el.value < parseFloat(el.input.getAttribute('max'))) {
						el.value += 1;
					}
				} else {
					el.value += 1;
				}
				if (isNaN(el.value)) {
					el.value = 1;
				}
				el.input.dispatchEvent(changeEvent);
				e.preventDefault();
			});
			el.input.addEventListener('change', function () {
				el.value = parseFloat(el.value);
				if (isNaN(el.value)) {
					el.value = 1;
					el.decr.classList.add('disabled');
				}
			});
		});
	}
});
window.dispatchEvent(semanticInputEvt);

// Togglable input
window.addEventListener("accordeon", function (evt) {
	var input_show = document.querySelectorAll('.input-show > label');
	if (input_show.length) {
		Array.from(input_show).forEach(function (el) {
			"use strict";
			append_url(el, 'Toggle', 'toggle');
			el.querySelectorAll('a.toggle')[0].addEventListener('click', function (e) {
				el.parentElement.classList.toggle('toggle');
				setTimeout(function () {
					el.parentElement.querySelectorAll('input, textarea')[0].focus();
				}, 0);
				e.preventDefault();
			});
		});
	}
});
window.dispatchEvent(accordeonEvt);

// .l4ne.featured - prepend the big image before the list on mobile device (blog)
var list_news = document.getElementsByClassName('l4ne');
if (list_news.length) {
	Array.from(list_news).forEach(function (el) {
		"use strict";
		if (el.classList.contains('featured')) {
			Array.from(el.querySelectorAll('li:first-child')).forEach(function (el) {
				var clone_me = el.cloneNode(true),
					clone_cont = document.createElement('ul'),
					list = el.closest('.l4ne');
				clone_cont.classList.add('mobile-only', 'l4ne', 'l4ne-figure-before');
				el.closest('li').classList.add('mobile-hide');
				list.before(clone_cont);
				if (list.previousElementSibling.classList.contains('l4ne-figure-before')) {
					list.previousElementSibling.append(clone_me);
				}
			});
		}
	});
}

// Countdown (product page) - legacy, don't use
/*var scheme_countdown = document.getElementsByClassName('s1cu');

function updateTimer(el, alias) {
	'use strict';
	var future = Date.parse(alias),
		diff = future - new Date(),

		days = Math.floor(diff / (1000 * 60 * 60 * 24)),
		hours = Math.floor(diff / (1000 * 60 * 60)),
		mins = Math.floor(diff / (1000 * 60)),
		secs = Math.floor(diff / 1000),

		d = days,
		h = hours - days * 24,
		m = mins - hours * 60,
		s = secs - mins * 60;

	el.innerHTML = '<span class="count-item day" data-count="' + d + '">' + d + ' <span class="count-label">days</span></span> ' + '<span class="count-item hour" data-count="' + h + '">' + h + ' <span class="count-label">hours</span></span><span class="sep">:</span> ' + '<span class="count-item min" data-count="' + m + '">' + m + ' <span class="count-label">minutes</span></span><span class="sep">:</span> ' + '<span class="count-item sec" data-count="' + s + '">' + s + ' <span class="count-label">seconds</span></span>';
}
Array.from(scheme_countdown).forEach(function (el) {
	var inner = el.innerHTML;
	updateTimer(el, inner);
	window.setInterval(function () {
		updateTimer(el, inner);
	}, 1000);
});*/

// Update text based on title (product page)
var data_change = document.querySelectorAll('a[data-change][title], input[data-change][title]');
if (data_change.length) {
	Array.from(data_change).forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			Array.from(document.querySelectorAll(el.getAttribute('data-change'))).forEach(function (em) {
				em.innerHTML = el.getAttribute('title');
			});
			if (el.tagName.toLowerCase() === 'a') {
				e.preventDefault();
			}
		});
	});
}

// Self-embedded YouTube/Vimeo
var data_self_video = document.querySelectorAll('a[data-youtube], a[data-vimeo]');
if (data_self_video.length) {
	Array.from(data_self_video).forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			var iframeCont = createElementWithClass('iframe', 'iframe-playing');
			iframeCont.setAttribute('frameborder', 0);
			iframeCont.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
			iframeCont.setAttribute('allowfullscreen', '');
			if (el.hasAttribute('data-youtube')) {
				iframeCont.setAttribute('src', 'https://www.youtube.com/embed/' + el.getAttribute('data-youtube') + '?autoplay=1&amp;rel=0');
			}
			if (el.hasAttribute('data-vimeo')) {
				iframeCont.setAttribute('src', 'https://player.vimeo.com/video/' + el.getAttribute('data-vimeo') + '?autoplay=1');
			}
			el.appendChild(iframeCont);
			e.preventDefault();
		});
	});
}

// f8ps extra space & display (product page)
var form_product_sticky = document.getElementsByClassName('f8ps'),
	form_product = document.getElementsByClassName('f8pr');
if (form_product_sticky.length) {
	Array.from(form_product_sticky).forEach(function (el) {
		"use strict";
		html_tag.classList.add('product-not-scrolled');
		aria_hide(el);
		root_id.style.paddingBottom = el.offsetHeight + 'px';
		Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
			el.setAttribute('tabindex', -1);
		});
		/*el.addEventListener('submit', function (e) {
			new_css('form-validation-css', path_css + 'async-validation.css');
		});*/
	});
}
// if (form_product.length) {
// 	Array.from(form_product).forEach(function (el) {
// 		"use strict";
		/*el.addEventListener('submit', function (e) {
			new_css('form-validation-css', path_css + 'async-validation.css');
		});*/
// 	});
// }

// Cookie bar
var cookie_id = document.getElementById('cookie-bar'),
	cookie_popup = document.querySelector('[data-title*="cookie"][data-popup-delay]');

function hideCookieBanner() {
	"use strict";
	if (cookie_popup) {
		cookie_popup.removeAttribute('data-popup-delay');
	}
	setTimeout(function () {
		html_tag.classList.remove('cookie-on');
	}, 400);
	if (!form_product_sticky.length) {
		root_id.removeAttribute('style');
	}
}

function cookieClick(el) {
	"use strict";
	html_tag.classList.add('cookie-toggle');
	if (el.classList.contains('cookie-accept')) {
		handleCookieAccept();
	} else if (el.classList.contains('cookie-decline')) {
		handleCookieDecline();
	} else {
		hideCookieBanner();
	}
	if (!form_product_sticky.length) {
		root_id.removeAttribute('style');
	}
	setTimeout(function () {
		html_tag.classList.remove('cookie-on');
	}, 400);
	Cookies.set('cookie-bar', 'no');
}

function handleCookieAccept() {
	"use strict";
	Cookies.set('cookie-bar', 'no');
	window.Shopify.customerPrivacy.setTrackingConsent(true, hideCookieBanner);
}

function handleCookieDecline() {
	"use strict";
	Cookies.set('cookie-bar', 'no');
	window.Shopify.customerPrivacy.setTrackingConsent(false, hideCookieBanner);
}

if (cookie_id || cookie_popup) {
	window.Shopify.loadFeatures([
		{
			name: 'consent-tracking-api',
			version: '0.1',
		}
	  ],
	function (error) {
		if (error) {
			throw error;
		}
		const shouldShowGDPRBanner = window.Shopify.customerPrivacy.shouldShowGDPRBanner();
		if (!shouldShowGDPRBanner) {
			Cookies.set('cookie-bar', 'no');
		}
	});

	if (!form_product_sticky.length && cookie_id) {
		html_tag.classList.remove('cookie-on');
		root_id.style.paddingBottom = cookie_id.offsetHeight + 'px';
	}
	append_url(root_id, 'Close', 'cookie-close');
	Array.from(document.querySelectorAll('.cookie-close, .cookie-decline, .cookie-accept')).forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			cookieClick(el);
			e.preventDefault();
		});
	});
}
if (Cookies.get('cookie-bar') === 'no') {
	hideCookieBanner();
} else {
	html_tag.classList.add('cookie-on');
}


// f8pr - sticky compact form
if (form_product.length) {
	Array.from(form_product).forEach(function (el) {
		"use strict";
		var dist;
		if (header_id) {
			dist = header_id.offsetHeight;
		} else {
			dist = 0;
		}

		function io(entries) {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					html_tag.classList.remove('product-scrolled');
					html_tag.classList.add('product-not-scrolled');
					Array.from(form_product_sticky).forEach(function (el) {
						aria_hide(el);
					});
				} else {
					html_tag.classList.add('product-scrolled');
					html_tag.classList.remove('product-not-scrolled');
					Array.from(form_product_sticky).forEach(function (el) {
						aria_show(el);
					});
					new_css('css-product-scrolled', '//trellisblissindia.com/cdn/shop/t/15/assets/async-product-scrolled.css?v=130788826303960621091792476872');
				}
			});
		}
		new IntersectionObserver(io, {
			rootMargin: -dist + 'px'
		}).observe(el);
	});
}

// Custom look of select boxes
window.addEventListener("semanticSelect", function (evt) {
	var select_tag = document.querySelectorAll('select:not(.semantic-select-initialized):not(.js-hidden)');
	if (select_tag.length && !window.mobileCheck()) {
		loadRes("//trellisblissindia.com/cdn/shop/t/15/assets/plugin-selects.js?v=23358290364911853201792476929", function () {
			"use strict";
			Array.from(select_tag).forEach(function (el) {
				el.classList.add('semantic-select-initialized');
				var sp = '',
						bvsel;
				if (el.hasAttribute('data-search-placeholder')) {
					sp = el.getAttribute('data-search-placeholder');
				}
				el.setAttribute('tabindex', -1);

				el.parentNode.classList.add('has-select');
				//if (el.querySelectorAll('option[selected]:not([disabled]), option[selected]:not(.disabled), option[selected]:not([data-class="disabled"])').length) {
				if (el.querySelectorAll('option[selected]:not([disabled], .disabled, [data-class="disabled"])').length) {
					el.parentNode.classList.add('done');
				}

				/* Selects without an id cannot be targeted by BVSelect; leave them as native selects instead of throwing */
				if (!window.mobileCheck() && el.getAttribute('id')) {
					try {
					wrap(el, document.createElement('span'), 'select-wrapper');
					randomize(el);
					bvsel = new BVSelect({
						selector: '#' + el.getAttribute('id') + '[data-random="' + el.dataset.random + '"]',
						searchbox: true,
						search_placeholder: sp,
						search_autofocus: true,
						offset: false
					});
					Array.from(el.nextSibling.querySelectorAll('.bv_ul_inner a')).forEach(function (em) {
						em.addEventListener('click', function () {
							el.dispatchEvent(changeEvent);
							if (em.closest('.form-group') !== null) {
								em.closest('.form-group').classList.remove('is-invalid');
							}
						});
					});
					Array.from(el.parentNode.getElementsByClassName('bv_atual')).forEach(function (em) {
						em.addEventListener('click', function () {
							new_css('css-select', '//trellisblissindia.com/cdn/shop/t/15/assets/async-select.css?v=165505224984377879971792476873');
						});
						em.addEventListener('focus', function () {
							new_css('css-select', '//trellisblissindia.com/cdn/shop/t/15/assets/async-select.css?v=165505224984377879971792476873');
						});
					});
					} catch (bvErr) { /* keep the native select */ }
				}
			// 	bvsel = new BVSelect({
			// 		selector: '#' + el.getAttribute('id') + '[data-random="' + el.dataset.random + '"]',
			// 		searchbox: true,
			// 		search_placeholder: sp,
			// 		search_autofocus: true,
			// 		offset: false
			// 	});
			// 	var selectedValue = el.dataset.default;
			// 	if (selectedValue) {
			// 		for (var i = 0, count = el.options.length; i < count; i++) {
			// 			var option = el.options[i];
			// 			if (selectedValue == option.value || selectedValue == option.innerHTML) {
			// 				el.querySelector
			// 				bvsel.SetOption({
			// 				  type: "byValue",
			// 				  value: option.value
			// 				});
			// 			}
			// 		}
			// 	}
			// 	Array.from(document.querySelectorAll('.bv_ul_inner a')).forEach(function (em) {
			// 		em.addEventListener('click', function () {
			// 			el.dispatchEvent(changeEvent);
			// 			if (em.closest('.form-group') !== null) {
			// 				em.closest('.form-group').classList.remove('is-invalid');
			// 			}
			// 		});
			// 	});
			// 	Array.from(el.parentNode.getElementsByClassName('bv_atual')).forEach(function (em) {
			// 		em.addEventListener('click', function () {
			// 			new_css('css-select', '//trellisblissindia.com/cdn/shop/t/15/assets/async-select.css?v=165505224984377879971792476873');
			// 		});
			// 		em.addEventListener('focus', function () {
			// 			new_css('css-select', '//trellisblissindia.com/cdn/shop/t/15/assets/async-select.css?v=165505224984377879971792476873');
			// 		});
			// 	});
			});
		}, 'selects-loaded');
	}
});
window.dispatchEvent(semanticSelectEvt);

// sidebar sliding from the edge (product page, cart)
var module_product = document.getElementsByClassName('m6pr'),
		module_collection = document.querySelectorAll('.m6cl.sticky');
if (module_product.length || module_collection.length) {
	html_tag.classList.add('t1pr');
}

// sidebar sliding from the edge (product page, cart)
var module_panel = document.getElementsByClassName('m6pn'),
	a_module_panel = document.querySelectorAll('a[data-panel]');

function negTabIn(el) {
	"use strict";
	// Elements won't be tabbable.
	Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
		el.setAttribute('tabindex', -1);
	});
}
function posTabIn(el) {
	"use strict";
	// Elements will be tabbable.
	Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
		el.removeAttribute('tabindex');
	});
}

function hidePanels() {
	"use strict";
	var cld, m6pn_clicked;
	html_tag.classList.remove('m6pn-open');
	Array.from(module_panel).forEach(function (el) {
		// negTabIn(el);
		el.classList.remove('toggle');
		el.setAttribute('aria-hidden', true);
		Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
			el.setAttribute('tabindex', -1);
		});
	});
	m6pn_clicked = document.getElementsByClassName('m6pn-clicked');
	if (m6pn_clicked.length) {
		if (whatInput.ask() === 'keyboard') {
			setTimeout(function () {
				document.getElementsByClassName('m6pn-clicked')[0].focus();
			}, 100);
		}
	}
}
if (module_panel.length) {
	window.addEventListener("modulePanel", function(evt) {
		module_panel = document.getElementsByClassName('m6pn');
		Array.from(module_panel).forEach(function (el) {
			"use strict";
			el.setAttribute('aria-hidden', true);
			append_url(el, 'Close', 'm6pn-close');
			/*if (!document.querySelector('#root > .m6pn-close')) {
				append_url(root_id, 'Close', 'm6pn-close');
			}*/
			// setTimeout(function () {
				Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
					el.setAttribute('tabindex', -1);
				});
			// }, 500);
			Array.from(el.getElementsByClassName('m6pn-close')).forEach(function (em) {
				"use strict";
				em.addEventListener('click', function (e) {
					hidePanels();
					/*setTimeout(function () {
						console.log(document.querySelectorAll('a[data-panel="'+el.getAttribute('id')+'"]')[0]);
					}, 100);*/
					e.preventDefault();
				});
			});
		});
		document.onkeydown = function (evt) {
			"use strict";
			evt = evt || window.event;
			if (evt.key === 'Escape') {
				hidePanels();
			}
		};
	});
	window.dispatchEvent(modulePanelEvt);
}
if (a_module_panel.length) {
	window.addEventListener("modulePanelAnchor", function(evt) {
			var a_module_panel = document.querySelectorAll('a[data-panel]');

		Array.from(a_module_panel).forEach(function (el) {
			"use strict";
			var id = el.dataset.panel,
				href = el.getAttribute('href'),
				linked = document.querySelectorAll('.m6pn[id="' + id + '"]');

			function click_handler() {
				overlayClose();
				html_tag.classList.add('has-panels', 'm6pn-open');
				Array.from(a_module_panel).forEach(function (em) {
					em.classList.remove('m6pn-clicked');
				});
				el.classList.add('m6pn-clicked');
				Array.from(module_panel).forEach(function (el) {
					el.setAttribute('aria-hidden', true);
					el.classList.remove('toggle');
				});
				Array.from(linked).forEach(function (el) {
					el.classList.add('toggle');
					posTabIn(el)
					el.setAttribute('aria-hidden', false);
					Array.from(el.querySelectorAll('a, input, button, select, textarea, [role="button"]')).forEach(function (el) {
						el.removeAttribute('tabindex');
					});
					setTimeout(function () {
						el.querySelectorAll('a, input, button, select, textarea, [role="button"]')[0].focus();
					}, 100);
				});
				new_css('css-panels', '//trellisblissindia.com/cdn/shop/t/15/assets/async-panels.css?v=100312535537013636921792476871');
				/*setTimeout(function () {
					linked[0].querySelectorAll('a, input, button, select, textarea, [role="button"]')[0].focus();
				}, 100);*/
			}

			if (linked.length) {
				//el.setAttribute('href', '#' + id);
				el.setAttribute('aria-haspopup', true);
				el.setAttribute('aria-controls', id);
				/*el.setAttribute('id', id + '-control');
				Array.from(linked).forEach(function (el) {
					el.setAttribute('aria-labelledby', id + '-control');
					el.setAttribute('aria-describedby', id + '-control');
				});*/
				el.addEventListener('click', function (e) {
					if (id == 'cart') {
						ajaxCart.load();
					}
					click_handler(el);
					if (!href.includes('#')) {
						e.preventDefault();
					}
				});
				el.addEventListener('keyup', function (e) {
					if (e.key === ' ') {
						if (id == 'cart') {
							ajaxCart.load();
						}
						click_handler(el);
						e.preventDefault();
					}
				});
			}
		});
	});
	window.dispatchEvent(modulePanelAnchorEvt);
}

// function cartDistances() {
// 	var list_cart = document.getElementsByClassName('l4ca');
	/*if (list_cart.length) {
		Array.from(list_cart).forEach(function (el) {
			Array.from(el.querySelectorAll('li')).forEach(function (em) {
				var c = em.querySelector('.price'),
					d = em.querySelector('h1, h2, h3, h4, h5, h6'),
					e = em.querySelector('ul');
				enquire.register('screen and (max-width: 760px)', function () {
					if (c !== null) {
						if (html_tag.getAttribute('dir') === 'rtl') {
							if (d !== null) {
								d.style.paddingLeft = c.offsetWidth + 'px';
							}
							if ((em.classList.contains('has-discount')) && (e !== null)) {
								e.style.marginLeft = c.offsetWidth + 'px';
							}
						} else {
							if (d !== null) {
								d.style.paddingRight = c.offsetWidth + 'px';
							}
							if ((em.classList.contains('has-discount')) && (e !== null)) {
								e.style.marginRight = c.offsetWidth + 'px';
							}
						}
					}
				}).register('screen and (min-width: 760px)', function () {
					if (d !== null) {
						d.removeAttribute('style');
					}
					if (e !== null) {
						e.removeAttribute('style');
					}
				});
			});
		});
	}*/
// }
// cartDistances();


// Searchbox

function removeTextSearch() {
	"use strict";
	html_tag.classList.remove('search-full', 'user-form-active');
	html_tag.classList.add('search-cleared');
	//search_id.classList.remove('full', 'has-text');
	search_id.classList.remove('has-text', 'not-empty');
	search_input[0].value = '';
	search_input[0].focus();
	if (!search_input[0] === document.activeElement) {
		setTimeout(function () {
			search_input[0].focus();
		}, 250);
	}
	/*setTimeout(function () {
		search_input[0].focus();
	}, 50);
	setTimeout(function () {
		search_input[0].focus();
	}, 250);*/
}

function overlayClose(n) {
	"use strict";
	html_tag.classList.remove('search-compact-active', 'search-full', 'user-form-active', 'm2a', 'nav-hover', 'f8fl-open');
	//search_id.classList.remove('full', 'has-text');
	search_id.classList.remove('full', 'has-text');
	if (nav_id) {
		clear_mobile_nav();
		//remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
	}
	if (nav_top_id) {
		remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
	}
	if (nav_bar_id) {
		remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
	}
	if (nav_user_id) {
		remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
	}
	if (n !== true) {
		if (module_panel.length) {
			hidePanels();
		}
	}
	/*Array.from(search_input).forEach(function (en) {
		en.value = '';
	});*/
}

window.addEventListener("search", function(evt) {
	var search_id = document.getElementById('search'),
		header_id = document.getElementById('shopify-section-header');

	if (search_id) {
		var search_input = search_id.querySelectorAll('input');
		append_url(search_id, 'Toggle', 'toggle');
		if (search_id.classList.contains('compact')) {
			var search_compact_cont = document.createElement('span'),
				v_cm; //,
			//link = createElementWithClass('label', 'search-compact-toggle');
			if (nav_user_id) {
				if (nav_user_id.querySelectorAll('li.search.mobile-only').length) {
					v_cm = false;
				}
			}
			//if (v_cm === false) {
			search_compact_cont.classList.add('search-compact-cont');
			//search_compact_cont.appendChild(link);
			append_url(search_compact_cont, 'Close', 'search-compact-toggle', '#search');
			search_compact_cont.getElementsByClassName('search-compact-toggle')[0].setAttribute('aria-controls', 'search');
			if (v_cm === false) {
				search_compact_cont.classList.add('mobile-hide');
				html_tag.classList.add('t1srn');
			}
			search_id.before(search_compact_cont);
			//}
			/*if ((!html_tag.classList.contains('t1sr-desktop')) || (!html_tag.classList.contains('t1sr-mobile'))) {
				html_tag.classList.add('t1sr');
			}
			if (search_id.classList.contains('compact-desktop')) {
				html_tag.classList.add('t1sr-desktop');
			}
			if (search_id.classList.contains('compact-mobile')) {
				html_tag.classList.add('t1sr-mobile');
			}
			if (search_id.classList.contains('text-center-sticky')) {
				html_tag.classList.add('search-compact-is-centered');
			}*/
		}
		if (search_id.classList.contains('compact') && !search_id.classList.contains('compact-desktop') && !search_id.classList.contains('compact-mobile')) {
			negTabIn(search_id.getElementsByTagName('fieldset')[0]);
		} else if (search_id.classList.contains('compact-mobile')) {
			enquire.register('screen and (max-width: 760px)', function () {
				negTabIn(search_id.getElementsByTagName('fieldset')[0]);
			});
		} else if (search_id.classList.contains('compact-desktop')) {
			html_tag.classList.add('compact-desktop');
			enquire.register('screen and (min-width: 761px)', function () {
				negTabIn(search_id.getElementsByTagName('fieldset')[0]);
			});
		}
		if (search_id.classList.contains('no-overlay')) {
			html_tag.classList.add('no-search-overlay');
		}
		Array.from(search_id.querySelectorAll('form > p, fieldset > p')).forEach(function (el) {
			"use strict";
			append_url(el, 'Clear', 'clear-toggle');
			append_url(el, 'Clear', 'search-back');
			el.getElementsByClassName('search-back')[0].setAttribute('aria-controls', 'search');
			Array.from(el.querySelectorAll('.clear-toggle')).forEach(function (em) {
				em.addEventListener('click', function (e) {
					removeTextSearch();
					e.preventDefault();
				});
			});
		});
		search_id.addEventListener('submit', function (e) {
			"use strict";
			search_id.classList.add('processing');
			// e.preventDefault();
		});
		Array.from(search_input).forEach(function (el) {
			"use strict";
			el.addEventListener('keyup', function () {
				html_tag.classList.remove('m2a');
				if (el.value.length === 0) {
					html_tag.classList.remove('search-full', 'user-form-active');
					search_id.classList.remove('full', 'has-text', 'not-empty', 'processing');
				} else {
					html_tag.classList.add('search-full');
					search_id.classList.add('full', 'has-text', 'not-empty', 'processing');
					//cartDistances();
					setTimeout(function () {
						liveSearch(el);
					}, 300);
				}
			});
			el.addEventListener('focus', function () {
				html_tag.classList.add('search-focus');
				html_tag.classList.remove('nav-hover');
				if (nav_id) {
					remove_active_submenus(nav_id.querySelectorAll('a.toggle'));
				}
				if (nav_top_id) {
					remove_active_submenus(nav_top_id.querySelectorAll('a.toggle'));
				}
				if (nav_user_id) {
					remove_active_submenus(nav_user_id.querySelectorAll('a.toggle'));
				}
				if (nav_bar_id) {
					remove_active_submenus(nav_bar_id.querySelectorAll('a.toggle'));
				}
				new_css('css-search', '//trellisblissindia.com/cdn/shop/t/15/assets/async-search.css?v=14994719753100336791792476872');
			});
		});
		Array.from(search_id.querySelectorAll('a.toggle')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				clearCompactSearch();
				search_id.classList.remove('full');
				search_id.classList.remove('full', 'has-text', 'not-empty');
				html_tag.classList.remove('search-focus', 'search-full', 'user-form-active');
				e.preventDefault();
			});
		});
		/*Array.from(search_id.querySelectorAll('.search-back')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				compactSearch();
				e.preventDefault();
			});
		});
		Array.from(document.querySelectorAll('label[for="search_main"]')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				compactSearch();
				e.preventDefault();
			});
		});*/
		/*Array.from(document.querySelectorAll('a[href="#search"]')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				compactSearch();
				e.preventDefault();
			});
		});*/
		Array.from(header_id.querySelectorAll('[aria-controls="search"]')).forEach(function (el) {
			"use strict";
			el.setAttribute('href', '#' + search_id.getAttribute('id'));
			el.addEventListener('click', function (e) {
				compactSearch();
				e.preventDefault();
			});
			el.addEventListener('mouseover', function () {
				new_css('css-search', '//trellisblissindia.com/cdn/shop/t/15/assets/async-search.css?v=14994719753100336791792476872');
			});
		});
		// Hide #search when clicked outside;
		enquire.register('screen and (min-width: 761px)', function () {
			document.addEventListener('click', function (event) {
				"use strict";
				if (!(event.target.getAttribute('aria-controls') === 'search' || (event.target.closest('a[aria-controls]') !== null && event.target.closest('a[aria-controls]').getAttribute('aria-controls') === 'search') || event.target.closest('#search') !== null)) {
					clearCompactSearch();
				}
			});
		});


		function clearCompactSearch() {
			"use strict";
			html_tag.classList.remove('search-compact-active', 'search-full', 'user-form-active');
			search_id.classList.remove('full', 'has-text');
			search_id.classList.remove('full', 'has-text', 'not-empty');
			negTabIn(search_id.getElementsByTagName('fieldset')[0]);
			search_input[0].value = '';
			//search_input[0].removeAttribute('autofocus');
			//search_input[0].focus();
		}

		function compactRoom() {
			"use strict";
			var logo_id = document.getElementById('logo'),
				lg_off,
				el_off;

			if (html_tag.getAttribute('dir') === 'rtl') {
				el_off = header_outer.clientWidth - search_id.offsetLeft - search_id.clientWidth;
				lg_off = header_outer.clientWidth - logo_id.offsetLeft - logo_id.clientWidth;
			} else {
				el_off = search_id.offsetLeft;
				lg_off = logo_id.offsetLeft;
			}

			if (search_id.clientWidth + el_off < lg_off - logo_id.clientWidth) {
				//console.log('enough space');
				html_tag.classList.add('has-logo-room');
				html_tag.classList.remove('no-logo-room');
			} else {
				//console.log('NOT enough space');
				html_tag.classList.add('no-logo-room');
				html_tag.classList.remove('has-logo-room');
			}
		}
		/*window.addEventListener('resize', function () {
            compactRoom();
        });*/

		function compactSearch() {
			"use strict";
			if (html_tag.classList.contains('search-compact-active')) {
				clearCompactSearch();
			} else {
				new_css('css-search', '//trellisblissindia.com/cdn/shop/t/15/assets/async-search.css?v=14994719753100336791792476872');
				html_tag.classList.add('search-compact-active');
				html_tag.classList.remove('user-form-active', 'm2a', 'nav-hover', 'f8fl-open');
				search_id.classList.remove('full', 'has-text', 'not-empty');
				search_input[0].value = '';
				search_input[0].focus();
				if (!search_input[0] === document.activeElement) {
					setTimeout(function () {
						search_input[0].focus();
					}, 250);
				}
				posTabIn(search_id.getElementsByTagName('fieldset')[0]);

				//compactRoom();
				/*setTimeout(function () {
					search_input[0].focus();
				}, 50);
				setTimeout(function () {
					search_input[0].focus();
				}, 250);*/
			}
		}

	}
});
window.dispatchEvent(searchEvt);

// Newsletter pop-up
var newsletter_popup = document.querySelector('.popup-a[data-title="newsletter-popup"]');
if (newsletter_popup != null) {
	if (Cookies.get('has-newsletter') != 'no') {
		setTimeout( function() {
			loadPopup('newsletter-popup');
		}, ((1 - 0.5) * 1000));
	}
}

// Popups async (move the loaded function at the top of scripts-async + delete the below if buggy)
var loadPopup = function (id) {
	"use strict";
	loadRes('//trellisblissindia.com/cdn/shop/t/15/assets/plugin-popups.js?v=77594657764269757781792476973', function () {
		var allPopups = document.querySelectorAll('[class^="popup-"]:not(html)');
		if (allPopups && !document.documentElement.classList.contains('spi')) {
			allPopups.semanticPopup();
		}
		openPopup(id);
		Array.from(allPopups).forEach(function (el) {
			Array.from(el.getElementsByClassName('m6tb')).forEach(function (em) {
				if (typeof semanticTabs === 'function' && !el.classList.contains('tabs-initialized')) {
					semanticTabs(em);
				}
				em.classList.add('tabs-initialized');
			});
			Array.from(el.getElementsByClassName('f8vl')).forEach(function (em) {
				validator_run(em);
			});
		});
		if (cookie_popup) {
			Array.from(cookie_popup.querySelectorAll('.cookie-decline, .cookie-accept')).forEach(function (el) {
				"use strict";
				el.addEventListener('click', function (e) {
					cookieClick(el);
					e.preventDefault();
				});
			});
		}
		if (newsletter_popup) {
			Array.from(newsletter_popup.querySelectorAll('a.close')).forEach(function (el) {
				el.addEventListener("click", function(event) {
					Cookies.set('has-newsletter', 'no');
				});
			});
			newsletter_popup.querySelector('form').addEventListener("submit", function(event) {
				Cookies.set('has-newsletter', 'no');
			});
		}
	}, 'popup-loaded');
};

var allApopups = document.querySelectorAll('a[data-popup], form[data-popup]'),
		formPopups = document.querySelectorAll('form[data-popup]');

function popupFocus(im) {
	setTimeout(function () {
		if (document.querySelectorAll('[data-title="' + im + '"]')[0].querySelectorAll('a, input, button, select, textarea, [role="button"]')[0] != undefined) {
			document.querySelectorAll('[data-title="' + im + '"]')[0].querySelectorAll('a, input, button, select, textarea, [role="button"]')[0].focus();
		}
	}, 100);
}
window.addEventListener("popups", function(evt) {
	allApopups = document.querySelectorAll('a[data-popup], form[data-popup]'),
	formPopups = document.querySelectorAll('form[data-popup]');
	for (var i = 0; i < allApopups.length; i++) {
		allApopups[i].addEventListener('click', function (event) {
			event.preventDefault();
			loadPopup(this.getAttribute('data-popup'));
			popupFocus(this.getAttribute('data-popup'));
		});
		Array.from(formPopups).forEach(function (el) {
			if (!el.classList.contains('f8vl')) {
				el.addEventListener('submit', function (event) {
					event.preventDefault();
					loadPopup(this.getAttribute('data-popup'));
					popupFocus(this.getAttribute('data-popup'));
				});
			}
		});
	}
});
window.dispatchEvent(popupsEvt);
var popup_delay = document.querySelectorAll('[data-popup-delay][data-title]');
if (popup_delay.length) {
	Array.from(popup_delay).forEach(function (el) {
		"use strict";
		setTimeout(function () {
			loadPopup(el.getAttribute('data-title'));
			popupFocus(el.getAttribute('data-title'));
		}, el.getAttribute('data-popup-delay'));
	});
}

// Popup with delay (integrated with the one above)
/*var popup_delay = document.querySelectorAll('[data-popup-delay][data-title]');
if (popup_delay.length) {
	Array.from(popup_delay).forEach(function (el) {
		"use strict";
		setTimeout(function () {
			openPopup(el.getAttribute('data-title'));
		}, el.getAttribute('data-popup-delay'));
	});
}*/
// Note on Vanilla JS it breaks the pages when popup is not defined
//openPopup('checkout');

// .l4cl
var list_collection = document.getElementsByClassName('l4cl');
if (list_collection.length) {
	Array.from(list_collection).forEach(function (el) {
		"use strict";

		// Show more links (cart)
		/*Array.from(el.querySelectorAll('li.link')).forEach(function (el) {
			el.addEventListener('click', function (e) {
				if (el.parentNode !== null) {
					el.parentNode.removeChild(el);
				}
				e.preventDefault();
			});
		});*/

		// Prepend big image before the list on mobile (index)
		Array.from(el.querySelectorAll('li:first-child figure.overlay')).forEach(function (el) {
			var clone_me = el.cloneNode(true);
			clone_me.classList.add('mobile-only', 'l4cl-figure-before');
			el.closest('li').classList.add('mobile-hide');
			el.closest('.l4cl').before(clone_me);
		});

		// Slider in popup (product)
		if (el.classList.contains('in-popup') && el.classList.contains('slider')) {
			if (el.children.length > 3) {
				el.classList.add('im-sliding');
			}
			//randomize(el);

			// SLIDER_IN_POPUP
			//setTimeout(function () {
			/*create_slider(el, {
				direction: 'horizontal',
				loop: false,
				autoHeight: true,
				slidesPerView: 3,
				spaceBetween: 16,
				pagination: {
					el: '.swiper-pagination-' + el.getAttribute('data-random'),
					clickable: true
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev',
				}
			});*/
			//}, 500);
		}
	});
}


// More link
function linkMore() {
	"use strict";
	var a_more = document.querySelectorAll('a.link-more:not(.link-more-initialized)');
	if (a_more.length) {
		Array.from(a_more).forEach(function (el) {
			if (el.tagName.toLowerCase() === 'a') {
				var parent = el.parentElement,
					parents = parent.parentElement,
					other_links = parents.querySelectorAll('a.link-more'),
					elements,
					limit = 5, // default limit that can be overwritten by defining the [data-limit] attribute
					inner_p;

				if (parents.classList.contains('check')) {
					if (el.hasAttribute('data-limit')) {
						limit = parseFloat(el.getAttribute('data-limit'));
					}
					Array.from(parents.querySelectorAll('li:nth-child(n+' + (limit + 1) + ')')).forEach(function (el) {
						if (!el.classList.contains('link-more')) {
							el.classList.add('hidden');
						}
					});
				}
				var elements = parents.querySelectorAll('.hidden, .was-hidden');

				el.classList.add('link-more-initialized');
				function detectLong(el, em) {
					if (el.clientHeight < el.scrollHeight) {
						em.classList.add('long');
					} else if (el.clientHeight === 0) {
					} else {
						em.classList.remove('long');
					}
				}
				if (parents.classList.contains('info')) {
					inner_p = parents.children[0];
					if (parents.querySelectorAll('p.hidden, p:not(.link-more) .hidden').length) {
						parents.classList.add('long');
					} else {
						detectLong(inner_p, parents);
						window.addEventListener('resize', function () {
							detectLong(inner_p, parents);
						});
					}
				}

				parent.classList.add('has-link-more');

				Array.from(other_links).forEach(function (el, index) {
					el.setAttribute('data-no', other_links.length - index);
				});
				el.addEventListener('click', function (e) {
					var parent = el.parentElement,
						parents = parent.parentElement,
						elements = parents.querySelectorAll('.hidden, .was-hidden');
					Array.from(elements).forEach(function (em) {
						if (em.classList.contains('hidden')) {
							em.classList.remove('hidden');
							em.classList.add('was-hidden');
						} else if (em.classList.contains('was-hidden')) {
							em.classList.remove('was-hidden');
							em.classList.add('hidden');
						}
					});
					if (parents.classList.contains('link-more-clicked')) {
						parents.classList.remove('link-more-clicked');
					} else {
						parents.classList.add('link-more-clicked');
					}
					e.preventDefault();
				});
			}
		});
	}
}
linkMore();


// .n6as (collection)
var nav_aside = document.querySelectorAll('.n6as a.toggle');
if (nav_aside.length) {
	nav_aside.forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			toggle_dropdowns_simple(el.parentElement);
			e.preventDefault();
		});
	});
}

window.addEventListener("gridListSwitch", function(evt) {
	// grid/list switcher (independent)

	var list_view = document.getElementsByClassName('l4vw');
	if (list_view.length) {
		Array.from(list_view).forEach(function (el) {
			"use strict";
			html_tag.classList.add('t1cl');
			if (el.getAttribute('aria-controls') !== null) {
				var im = el,
					view_item = el.querySelectorAll('li'),
					view_list = document.getElementById(im.getAttribute('aria-controls'));
				el.querySelectorAll('a > i[class*="icon-view-"]').forEach(function (el) {
					el.parentElement.addEventListener('click', function (e) {
						// console.log('a');
						view_item.forEach(function (el) {
							el.classList.remove('active');
						});
						setTimeout(function () {
							linkMore();
							window.dispatchEvent(new Event('resize'));
						}, 10);
						if (el.classList.contains('icon-view-list')) {
							saveCollectionview('list');
							view_list.classList.add('list');
							im.querySelectorAll('a > i.icon-view-list').forEach(function (el) {
								el.closest('li').classList.add('active');
							});
						}
						if (el.classList.contains('icon-view-grid')) {
							saveCollectionview('grid');
							view_list.classList.remove('list');
							im.querySelectorAll('a > i.icon-view-grid').forEach(function (el) {
								el.closest('li').classList.add('active');
							});
						}
						e.preventDefault();
					});
				});
			}
		});
	}

	// .m6cl, grid/list switcher (collection)
	// var module_collection = document.getElementsByClassName('m6cl');
	// if (module_collection.length) {
	// 	Array.from(module_collection).forEach(function (el) {
	// 		"use strict";
	// 		html_tag.classList.add('t1cl');
	// 		var im = el,
	// 			view_item = el.querySelectorAll('.l4vw li'),
	// 			view_list = el.querySelectorAll('.l4cl');
	// 		el.querySelectorAll('a > i[class*="icon-view-"]').forEach(function (el) {
	// 			el.parentElement.addEventListener('click', function (e) {
	// 				view_item.forEach(function (el) {
	// 					el.classList.remove('active');
	// 				});
	// 				if (el.classList.contains('icon-view-list')) {
	// 					saveCollectionview('list');
	// 					view_list.forEach(function (el) {
	// 						el.classList.add('list');
	// 					});
	// 					im.querySelectorAll('a > i.icon-view-list').forEach(function (el) {
	// 						el.closest('li').classList.add('active');
	// 					});
	// 				}
	// 				if (el.classList.contains('icon-view-grid')) {
	// 					saveCollectionview('grid');
	// 					view_list.forEach(function (el) {
	// 						el.classList.remove('list');
	// 					});
	// 					im.querySelectorAll('a > i.icon-view-grid').forEach(function (el) {
	// 						el.closest('li').classList.add('active');
	// 					});
	// 				}
	// 				e.preventDefault();
	// 			});
	// 		});
	// 	});
	// }
});
window.dispatchEvent(gridListSwitchEvt);

window.addEventListener("mobileFilters", function(evt) {
	// .f8sr (collection)
	var form_sort = document.getElementsByClassName('f8sr');
	if (form_sort.length) {
		Array.from(form_sort).forEach(function (el) {
			"use strict";
			html_tag.classList.add('t1cl');
			if (el.classList.contains('mobile-sticky')) {
				var dst = '0px',
					ofs = 0,
					trg = el.getElementsByClassName('link-btn')[0];

				if (trg !== undefined) {
					if (!html_tag.classList.contains('t1sn') && header_main && !header_main.classList.contains('no-sticky')) {
						if (header_id) {
							ofs = header_id.clientHeight;
						}
						if (header_id && nav_top_id) {
							ofs = header_id.clientHeight - nav_top_id.clientHeight;
						}
					}
					dst = '-' + parseFloat(ofs + 16) + 'px 0px ' + parseFloat(ofs + 16) + 'px 0px';

					function io2(entries) {
						entries.map((entry) => {
							if (el.getBoundingClientRect().top < (header_id.clientHeight + 20))
							if (entry.isIntersecting) {
								el.classList.remove('fixed');
								trg.removeAttribute('style');
							} else {
								el.classList.add('fixed');
								if (header_id) {
									trg.style.top = ofs + 'px';
								}
							}
						});
					}

					new IntersectionObserver(io2, {
						rootMargin: dst,
						threshold: 0.7
					}).observe(el);
				}
			}
		});
	}

	// .f8fl (collection)
	var form_filter = document.getElementsByClassName('f8fl');
	if (form_filter.length) {
		Array.from(form_filter).forEach(function (el) {
			"use strict";
			html_tag.classList.add('t1cl');
			append_url(el, 'Close', 'f8fl-toggle');
			//append_url(root_id, 'Close', 'f8fl-toggle', './', true);
			if (el.hasAttribute('id')) {
				Array.from(document.querySelectorAll('[href="#' + el.getAttribute('id') + '"]')).forEach(function (el) {
					el.classList.add('f8fl-toggle');
				});
			}
			Array.from(el.querySelectorAll('h1, h2, h3, h4, h5, h6')).forEach(function (el) {
				append_url(el, 'Close', 'header-toggle');
				el.querySelector('a.header-toggle').addEventListener('click', function (e) {
					toggle_dropdowns_simple(el);
					if (!el.hasAttribute('id')) {
						e.preventDefault();
					}
				});
			});
		});
		Array.from(document.getElementsByClassName('f8fl-toggle')).forEach(function (el) {
			"use strict";
			el.setAttribute('aria-controls', 'filter');
		});
		Array.from(document.querySelectorAll('a[aria-controls="filter"]')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				html_tag.classList.add('has-filters');
				html_tag.classList.toggle('f8fl-open');
				new_css('css-filters', '//trellisblissindia.com/cdn/shop/t/15/assets/async-filters.css?v=139812642784675163181792476869');
				e.preventDefault();
			});
		});
	}
});
window.dispatchEvent(mobileFiltersEvt);

// .input-range (collection)
window.addEventListener("rangeSlider", function(evt) {
	var input_range = document.getElementsByClassName('input-range');
	if (input_range.length) {
		loadRes("//trellisblissindia.com/cdn/shop/t/15/assets/plugin-sliders.js?v=113098746333069038651792476930", function () {
			"use strict";
			new_css('form-sliders-css', '//trellisblissindia.com/cdn/shop/t/15/assets/async-ui-sliders.css?v=90807160846424240761792476874');
			Array.from(input_range).forEach(function (el) {
				el.appendChild(createElementWithClass('div', 'range-inner'));
				var data_min = el.querySelectorAll('input[min]')[0],
					data_max = el.querySelectorAll('input[max]')[0];
				el.querySelectorAll('.range-inner').forEach(function (el) {
					if (!el.classList.contains('slider-is-here')) {
						noUiSlider.create(el, {
							start: [parseFloat(data_min.value), parseFloat(data_max.value)],
							connect: true,
							direction: global_dir[0],
							range: {
								'min': [parseFloat(data_min.getAttribute('min'))],
								'max': [parseFloat(data_max.getAttribute('max'))]
							}
						});
						el.noUiSlider.on('update', function (values, handle) {
							if (handle) {
								data_max.value = parseFloat(values[handle]).toFixed();
							} else {
								data_min.value = parseFloat(values[handle]).toFixed();
							}
						});
						el.noUiSlider.on('change', function (handle) {
							if (handle) {
								data_max.dispatchEvent(changeEvent);
							} else {
								data_min.dispatchEvent(changeEvent);
							}
						});
					}
					el.classList.add('slider-is-here');
				});
				window.dispatchEvent(inputPaddingEvt);
			});
		}, 'sliders-loaded');
	}
});
window.dispatchEvent(rangeSliderEvt);

// Masonry, .l4ft (index)
/*window.addEventListener("masonry", function(evt) {
	var list_featured = document.getElementsByClassName('l4ft');
	if (list_featured.length) {
		loadRes("//trellisblissindia.com/cdn/shop/t/15/assets/plugin-masonry.js?v=114914519776467730011792476929", function () {
			"use strict";
			Array.from(list_featured).forEach(function (el) {
				if (el.classList.contains('cols')) {
					el.classList.add('masonry-initialized');
					// var msnry = new Masonry(el, {
					new Masonry(el, {
						itemSelector: 'li',
						originLeft: global_dir[1],
						percentPosition: true
					});
					if (el.classList.contains('masonry-initialized')) {
						function io(entries) {
							entries.map((entry) => {
								if (entry.isIntersecting) {
									msnry.reloadItems();
								}
							});
						}
						new IntersectionObserver(io).observe(el);
						setTimeout(function () {
							msnry.reloadItems();
						}, 500);
					}
					//var aa = event.target.closest('.l4ft');
					//if (aa !== null) {
						//.destroy();
					//}
				}
			});
		}, 'masonry-loaded');
	}
});
window.dispatchEvent(masonryEvt);*/

// sticky header
window.addEventListener("stickyNav", function(evt) {
	var nav_id = document.getElementById('nav'),
		nav_top_id = document.getElementById('nav-top'),
		nav_bar_id = document.getElementById('nav-bar'),
		header_main = document.getElementById('header'),
		header_id = document.getElementById('shopify-section-header');
	// The rebuilt header (sections/header.liquid) has its own sticky logic and no #header element
	if (header_id && header_main) {

		if (document.querySelector('#nav-top:not(.no-js)')) {
			html_tag.classList.remove('t1nt');
		} else {
			html_tag.classList.add('t1nt');
		}

		if (nav_id) {
			if (nav_id.classList.contains('sticky-menu')) {
				html_tag.classList.add('t1sn');
			} else {
				html_tag.classList.remove('t1sn');
			}
		}

		var sa, le, distance_counter;
		// if (nav_top_id !== null || html_tag.classList.contains('t1nt')) {
		if ((nav_top_id !== null || html_tag.classList.contains('t1nt')) && nav_top_id !== null) {
			sa = nav_top_id.offsetHeight;
		} else {
			sa = 0;
		}

		if (html_tag.classList.contains('t1sn')) {
			// console.log("sticky nav bar");
			if (nav_bar_id) {
				le = nav_bar_id;
			} else {
				le = nav_id;
			}
			sa = 0;
		} else {
			le = header_id;
		}

		/*new Waypoint({
			element: le,
			handler: function () {
				le.classList.toggle('fixed');
			},
			offset: _of
		});*/

		function io(entries) {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					le.classList.remove('fixed');
				} else {
					le.classList.add('fixed');
					if (le.id === 'nav' || le.id === 'nav-bar') {
						enquire.register('screen and (min-width: 1000px)', function () {
							overlayClose(true);
						});
					}
					new_css('css-menu', '//trellisblissindia.com/cdn/shop/t/15/assets/async-menu.css?v=75317865920152203141792476870');
				}
			});
		}

		distance_counter = document.createElement('div');
		distance_counter.setAttribute('id', 'distance-counter');

		if (html_tag.classList.contains('t1sn')) {
			header_main.append(distance_counter);
		} else {
			distance_counter.style.top = le.getBoundingClientRect().top + window.scrollY + sa + 'px';
			//distance_counter.style.top = le.getBoundingClientRect().top + sa + 'px';
			root_id.after(distance_counter);
		}

		if (header_main.classList.contains('no-sticky')) {
			html_tag.classList.add('t1ns');
		}

		if (header_main && !header_main.classList.contains('no-sticky')) {
			new IntersectionObserver(io, {
				root: null,
				rootMargin: '0px',
				threshold: 0.9
			}).observe(distance_counter);
		} else {
			html_tag.classList.add('t1st');
		}

		/*const observer2 = new IntersectionObserver(ip, {
			rootMargin: (le.getBoundingClientRect().top + window.scrollY)+'px',
			threshold: 1
		});
		observer2.observe(root_id);*/
	}

	// Closeable top bar
	top_bar = document.getElementById('shopify-section-announcement-bar');
	if (top_bar) {
		append_url(top_bar, 'Close', 'close');
		top_bar.querySelector('a.close').addEventListener('click', function (e) {
			"use strict";
			top_bar.parentNode.removeChild(top_bar);
			//Waypoint.refreshAll();
			if (typeof Shopify !== 'undefined' && Shopify.designMode) { } else {
				Cookies.set('notice', 'closed');
			}

			/*if (document.querySelectorAll('#distance-counter') != 'undefined') {

			}*/
			distance_counter.style.top = le.getBoundingClientRect().top + window.scrollY + sa + 'px';
			e.preventDefault();
		});
		if (Cookies.get('notice') === 'closed') {
			/*Array.from(top_bar).forEach(function (el) {
				"use strict";
				if (el.parentNode !== null) {
					el.parentNode.removeChild(el);
				}
			});*/
			if (top_bar.parentNode !== null) {
				top_bar.parentNode.removeChild(top_bar);
			}
		} else {
			html_tag.classList.add('show-notice');
		}
	}

	if (top_bar) {
		append_url(top_bar, 'Close', 'overlay-close');
	}

	if (header_id) {
		append_url(root_id, 'Close', 'overlay-close');
		append_url(header_id, 'Close', 'overlay-close');
		if (search_id) {
			if (nav_id) {
				append_url(nav_id, 'Close', 'overlay-close');
			}
			if (nav_bar_id) {
				append_url(nav_bar_id, 'Close', 'overlay-close');
			}
		}
		if (header_outer) {
			append_url(header_outer, 'Close', 'overlay-close');
		}
		Array.from(document.querySelectorAll('a.overlay-close')).forEach(function (el) {
			"use strict";
			el.addEventListener('click', function (e) {
				overlayClose();
				e.preventDefault();
			});
		});
	}
});
window.dispatchEvent(stickyNavEvt);

// Countdown timer
window.addEventListener("countdown", function(evt) {
	var countdown_tag = document.getElementsByClassName('countdown');

	if (countdown_tag.length) {
		loadRes('//trellisblissindia.com/cdn/shop/t/15/assets/plugin-countdown.js?v=68240045042427389931792476928', function () {
			"use strict";
			Array.from(countdown_tag).forEach(function (el) {
				var container = el.closest('li'),
					parentContainer = container.parentElement,
					now = new Date(),
					nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()),
					show_until = new Date(),
					show_from = new Date(),
					word_day,
					word_days,
					word_hour,
					word_hours,
					word_min,
					word_mins,
					word_sec,
					word_secs,
					show_from_data = parseInt(el.getAttribute('data-show-from')),
					show_until_data = el.getAttribute('data-show-until').split(':'),
					show_days = el.getAttribute('data-show-days'),
					timezone_offset = parseInt(el.getAttribute('data-timezone-offset')),
					show_from_hours = show_from_data,
					show_until_hours = parseInt(show_until_data[0]),
					show_until_minutes = parseInt(show_until_data[1]),
					nowMinutes = (nowUTC.getHours() * 60) + nowUTC.getMinutes(),
					show_fromMinutes = ((show_from_hours - timezone_offset) * 60),
					show_untilMinutus = ((show_until_hours - timezone_offset) * 60) + show_until_minutes

				show_from.setHours(show_from_hours + timezone_offset, 0, 0);
				show_until.setHours(show_until_hours + timezone_offset, show_until_minutes, 0);

				if (show_fromMinutes > nowMinutes || nowMinutes > show_untilMinutus || !show_days.includes(nowUTC.getDay())) {
					container.remove();
					if (parentContainer.classList.contains('l4ch')) {
						if (parentContainer.children.length === 0 || parentContainer.children[0].classList.contains('invalid-feedback') ) {
							if (parentContainer.nextElementSibling != null && parentContainer.nextElementSibling.nodeName == 'HR') { parentContainer.nextElementSibling.remove(); }
							parentContainer.remove();
						}
					}

					return;
				}

				el.innerHTML = '<span class="hidden">' + el.innerHTML + '</span>';

				if (el.getAttribute('data-day') !== null) {
					word_day = el.getAttribute('data-day');
				} else {
					word_day = 'day';
				}
				if (el.getAttribute('data-days') !== null) {
					word_days = el.getAttribute('data-days');
				} else {
					word_days = 'days';
				}
				if (el.getAttribute('data-hour') !== null) {
					word_hour = el.getAttribute('data-hour');
				} else {
					word_hour = 'hour';
				}
				if (el.getAttribute('data-hours') !== null) {
					word_hours = el.getAttribute('data-hours');
				} else {
					word_hours = 'hours';
				}
				if (el.getAttribute('data-minute') !== null) {
					word_min = el.getAttribute('data-minute');
				} else {
					word_min = 'minute';
				}
				if (el.getAttribute('data-minutes') !== null) {
					word_mins = el.getAttribute('data-minutes');
				} else {
					word_mins = 'minutes';
				}
				if (el.getAttribute('data-second') !== null) {
					word_sec = el.getAttribute('data-second');
				} else {
					word_sec = 'second';
				}
				if (el.getAttribute('data-seconds') !== null) {
					word_secs = el.getAttribute('data-seconds');
				} else {
					word_secs = 'seconds';
				}
				//const target = document.querySelector('.countdown');
				/*const options = {
					rootMargin: '150px'
				}*/

				function renderMe() {
					if (!el.classList.contains('done')) {
						simplyCountdown(el, {
							year: show_until.getFullYear(),
							month: show_until.getMonth() + 1,
							day: show_until.getDate(),
							hours: show_until.getHours(),
							minutes: show_until.getMinutes(),
							seconds: show_until.getSeconds(),
							enableUtc: true,
							// enableUTC: false,
							//inline: true,
							zeroPad: true,
							onEnd: function() { el.closest('li').remove(); },
							words: {
								days: {
									singular: word_day,
									plural: word_days
								},
								hours: {
									singular: word_hour,
									plural: word_hours
								},
								minutes: {
									singular: word_min,
									plural: word_mins
								},
								seconds: {
									singular: word_sec,
									plural: word_secs
								}
							}
						});
						el.classList.add('done');
						container.classList.add('done');
					}

				}
				renderMe();
				/*if (el.getBoundingClientRect().y < window.innerHeight) {
					renderMe();
				}

				function io(entries) {
					entries.map((entry) => {
						if (entry.isIntersecting) {
							renderMe();
						}
					});
				}
				new IntersectionObserver(io).observe(el);*/
			});
		}, 'countdown-loaded');
	}
});
window.dispatchEvent(countdownEvt);

// scheme-progress (scheme-progress)
var scheme_progress = document.getElementsByClassName('scheme-progress');
if (scheme_progress.length) {
	Array.from(scheme_progress).forEach(function (el) {
		"use strict";
		if (el.hasAttribute('data-val') && el.hasAttribute('data-of')) {
			var vl = parseFloat(el.getAttribute('data-val')),
				ol = parseFloat(el.getAttribute('data-of')),
				ng = document.createElement('span');

			ng.classList.add('bar');
			//ng.innerHTML = '<span style="width: ' + (ol - vl) * ol * 0.01 + '%;"></span>';
			ng.innerHTML = '<span style="width: ' + vl / ol * 100 + '%;"></span>';
			el.appendChild(ng);

		}
		/*if (scheme_progress.length) {
			scheme_progress.filter('[data-val][data-of]').each(function () {
				var vl = parseFloat($(this).attr('data-val')),
					ol = parseFloat($(this).attr('data-of'));
				$(this).append('<div class="bar"><div style="width:' + (ol - vl) * ol * 0.01 + '%;"></div></div>');
			});
		}*/
	});
}

// Count up (l4cu)
var list_count = document.getElementsByClassName('l4cu');
if (list_count.length) {
	loadRes('//trellisblissindia.com/cdn/shop/t/15/assets/plugin-countup.js?v=5247233202990784951792476928', function () {
		"use strict";
		Array.from(list_count).forEach(function (em) {
			Array.from(em.querySelectorAll('span:first-child')).forEach(function (el) {
				var clone_me = el.cloneNode(true),
					str = el.innerHTML;
				el.innerHTML = '<span class="main">' + el.innerHTML + '</span>';
				clone_me.classList.add('clone');
				/*if (el.innerHTML.indexOf('+') > -1) {
					clone_me.classList.add('has-plus');
					str = str.replace('+', '');
				}*/
				clone_me.setAttribute('data-val', str);
				el.appendChild(clone_me);
				el.classList.add('cont');
			});

			function renderMe() {
				Array.from(em.querySelectorAll('span.clone')).forEach(function (el) {
					var decimals,
						str = el.innerHTML,
						counting;
					if (el.innerHTML.indexOf('+') > -1) {
						el.innerHTML = el.innerHTML.replace('+', '');
						str = str.replace('+', '');
						el.classList.add('has-plus');
					}
					if (el.innerHTML.indexOf('.') > -1) {
						decimals = str.length - str.indexOf('.') - 1;
					} else {
						decimals = 0;
					}
					if (typeof CountUp === 'function') {
							counting = new CountUp(el, parseFloat(el.getAttribute('data-val')), {
							decimalPlaces: decimals,
							duration: 3
						});
						if (!counting.error) {
							counting.start();
						}
					}
				});
			}
			//console.log(em.getBoundingClientRect().y < window.innerHeight);
			if (em.getBoundingClientRect().y < window.innerHeight) {
				renderMe();
			}

			function io(entries) {
				entries.map((entry) => {
					if (entry.isIntersecting) {
						renderMe();
					}
				});
			}
			new IntersectionObserver(io).observe(em);
		});
	}, 'countup-loaded');
}

function updateSliders(el) {
	"use strict";
	if (el.classList.contains('s4wi') /*&& !html_tag.classList.contains('theme-editor')*/) {
		var sl_el = el.querySelector('.swiper-outer');

		function io(entries) {
			entries.map((entry) => {
				if (entry.isIntersecting) {
					if (sl_el.swiper !== null) {
						sl_el.swiper.updateAutoHeight();
					}
				}
			});
		}
		new IntersectionObserver(io).observe(el);
		setTimeout(function () {
			if (sl_el.swiper !== null) {
				sl_el.swiper.updateAutoHeight();
			}
		}, 300);
	}
}
window.addEventListener("updateSliders", function(evt) {
	var list_collection_slider = document.querySelectorAll('.l4cl.slider:not(.in-popup)');
	if (list_collection_slider.length) {
		Array.from(list_collection_slider).forEach(function (em) {
			"use strict";
			updateSliders(em);
		});
	}
	var module_featured = document.querySelectorAll('.m6fr');
	if (module_featured.length) {
		Array.from(module_featured).forEach(function (em) {
			"use strict";
			updateSliders(em);
		});
	}
});
window.dispatchEvent(updateSlidersEvt);

// Floating alerts (l4al)
window.addEventListener("alerts", function(evt) {
	var list_alerts = document.querySelectorAll('.l4al:not(.inline)');
	function countUs(element) {
		"use strict";
		if (element.children.length === element.querySelectorAll('li.hidden').length) {
			element.classList.add('all-hidden');
		} else {
			element.classList.remove('all-hidden');
		}
	}
	if (list_alerts.length) {
		Array.from(list_alerts).forEach(function (em) {
			"use strict";
			countUs(em);
			Array.from(em.querySelectorAll('a.close')).forEach(function (el) {
				asyncCSS();
				el.addEventListener('click', function (e) {
					el.closest('li').classList.add('fade-me-out');
					setTimeout(function () {
						el.closest('li').classList.add('hidden');
					}, 400);
					e.preventDefault();
				});
			});
			if (em.parentNode.id === 'root') {
				Array.from(em.querySelectorAll('li')).forEach(function (es) {
					var dl = 5000;
					asyncCSS();
					setTimeout(function () {
						es.classList.add('fade-me-out');
					}, dl);
					setTimeout(function () {
						es.classList.add('hidden');
						countUs(em);
					}, dl + 400);
				});
			}
		});
	}
});
window.dispatchEvent(alertsEvt);

// Print page
var link_print = document.getElementsByClassName('link-print');
if (link_print.length) {
	Array.from(link_print).forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			new_css('css-print', '//trellisblissindia.com/cdn/shop/t/15/assets/async-print.css?v=89185069024288619601792476872');
			setTimeout(function () {
				window.print();
			}, 400);
			e.preventDefault();
		});
	});
}

var link_copy = document.querySelectorAll('a[data-copy]');
if (link_copy.length) {
	const copyToClipboardAsync = str => {
		if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(str);
		}
		return Promise.reject('The Clipboard API is not available.');
	};
	Array.from(link_copy).forEach(function (el) {
		"use strict";
		el.addEventListener('click', function (e) {
			el.classList.add('clicked');
			copyToClipboardAsync(el.dataset.copy);
			setTimeout(function () {
				el.classList.remove('clicked');
			}, 2000);
			e.preventDefault();
		});
	});
}

	// tooltip
	window.addEventListener("tooltip", function (evt) {
	var scheme_tip = document.getElementsByClassName('scheme-tip');
	Array.from(scheme_tip).forEach(function (el) {
		"use strict";
		el.innerHTML = '<a class="tip-toggle" href="./"></a> <span class="tip"><span class="tip-inner">' + el.innerHTML + '</span> <a class="tip-toggle" href="./">Close</a></span>';
		Array.from(el.getElementsByClassName('tip-toggle')).forEach(function (em) {
			em.addEventListener('click', function (e) {
				el.classList.toggle('toggle');
				e.preventDefault();
			});
		});
		el.classList.add('ready');
	});
});
window.dispatchEvent(tooltipEvt);

window.addEventListener("fancybox", function (evt) {
	// has-more toggles fancybox
	var swipper_bullets = document.querySelectorAll('a.swiper-pagination-bullet');
	Array.from(swipper_bullets).forEach(function (el, index) {
		"use strict";
		el.addEventListener('click', function (e) {
			if (el.classList.contains('has-more')) {
				var data_fancybox = document.querySelectorAll('[data-fancybox]');
				data_fancybox[index].click();
			}
			return true;
		});
	});

	// Fancybox
	function createFancyboxAndShowItem(itemIndex, fancyName) {
		"use strict";
		// Enable/disable swipe support for fancybox based on the type of the displayed item
		function toogleTouchSupportOnItem(item, fancybox) {
			var touchStateForItem = true;
			if (item.type !== "image") {
				touchStateForItem = false;
			}

			if (fancybox.Carousel.Panzoom.options.touch !== touchStateForItem) {
				fancybox.Carousel.Panzoom.options.touch = touchStateForItem;
				fancybox.Carousel.updatePanzoom();
			}
		}
		var showItems = [],
			all_items = document.querySelectorAll(`[data-fancybox="${fancyName}"]`),
			item,
			fbox;

		all_items.forEach(item => {
			var src_type = null,
					hrefItem = item.getAttribute('href'),
					thumbImg = item.querySelector('img').getAttribute('src'),
					caption = item.getAttribute('data-caption'),
					alt = item.getAttribute('data-alt'),
					title = item.getAttribute('data-title');
			if (endsWithAny(['jpg', 'jpeg', '.gif', '.png', '.webp'], hrefItem)) {
				src_type = 'image';
			}
			if (hrefItem.indexOf('youtube.com/watch') !== -1 || hrefItem.indexOf('vimeo.com/') !== -1) {
				src_type = 'video';
			}
			if (endsWithAny(['mp4', 'webm', 'ogg'], hrefItem)) {
				src_type = 'html5video';
			}
			// check if item was already added to showItems array to avoid duplication
			if (!showItems.find(_item => _item.src === hrefItem)) {
				showItems.push({
					src: hrefItem,
					type: src_type,
					preload: false,
					animated: false,
					caption: caption,
					thumb: thumbImg,
					baseClass: 'myCustomClass'
				});
			}
		});
		fbox = new Fancybox(showItems, {
			startIndex: itemIndex || 0,
			Carousel: {
				Panzoom: {
					touch: true
				}
			},
			Html: {
				video: {
					autoplay: false
				}
			},
			/*caption: function (fancybox, carousel, slide) {
				return (
					all_items[itemIndex].getAttribute('data-caption')
				);
			},*/
			on: {
				/*done: (fancybox, slide) => {
					console.log(`#${slide.index} slide is loaded!`);
					console.log(
						`This slide is selected: ${fancybox.getSlide().index === slide.index}`
					);
				},*/
				ready: function (_fancybox) {
					toogleTouchSupportOnItem(_fancybox.items[_fancybox.Carousel.page], _fancybox);
					// show thumbs
					_fancybox.plugins.Thumbs.toggle();
					if (_fancybox.plugins.Thumbs.state == 'hidden') {
						_fancybox.plugins.Thumbs.show();
					}
				},
				done: function (_fancybox, carousel, slide) {
					// check if there's model-viewer
					var slides = _fancybox.$container.querySelectorAll('div.fancybox__thumbs div.carousel__slide'),
							all_items = document.querySelectorAll('[data-fancybox]'),
							getClass = _fancybox.$container.querySelectorAll('.fancybox__slide.is-selected')[0];
					//console.log(showItems);
					//console.log(carousel.$content.childNodes[0])
					//console.log(_fancybox.$carousel.children[0].querySelectorAll('.fancybox__slide:first-child .fancybox__content > *'))
					if (slides.length < all_items.length) {
						return;
					}
					var ar_buttons = _fancybox.$container.querySelectorAll('div.fancybox__carousel model-viewer + [data-shopify-xr]');
					if (ar_buttons.length) {
						ar_buttons.forEach(function (el, index) {
							el.style.bottom = _fancybox.$container.querySelectorAll('div.fancybox__thumbs')[0].offsetHeight + 23 + "px";
						});
					}
					all_items.forEach(function (el, index) {
						if (el.querySelectorAll('model-viewer').length > 0) {
							// if (slides.length > index) {
								slides[index].classList.add("has-cube");
							// }
						}
					});
					//fbox.updatePage()
					if (getClass !== undefined) {
						_fancybox.$container.setAttribute('data-class', getClass.getAttribute('class'));
					}
				},
				"Carousel.change": function (_fancybox, carousel, slide) {
					var getClass;
					//carousel.options.slidesPerPage = 2;
					//console.log(_fancybox.options.Html.video.autoplay)
					//console.log(carousel);
					var iframe = _fancybox.$container.getElementsByTagName("iframe");
					Array.from(iframe).forEach(function (el) {
			      var url = el.getAttribute('src');
			      el.setAttribute('src', '');
			      el.setAttribute('src', url);
					});
					setTimeout(function () {
						getClass = _fancybox.$container.querySelectorAll('.fancybox__slide.is-selected')[0];
						if (getClass !== undefined) {
							_fancybox.$container.setAttribute('data-class', getClass.getAttribute('class'));
						}
					}, 100);
	 				toogleTouchSupportOnItem(_fancybox.items[carousel.page], _fancybox);
	 			}
			}
		});
	}
	var data_fancybox = document.querySelectorAll('[data-fancybox]');
	if (data_fancybox.length) {
		Array.from(data_fancybox).forEach(function (el, index) {
			"use strict";
			var hrefItem = el.getAttribute('href');
			if (hrefItem.indexOf('youtube.com/watch') !== -1 || hrefItem.indexOf('vimeo.com/') !== -1) {
				el.setAttribute('data-type', 'video');
			}
			if (endsWithAny(['mp4', 'webm', 'ogg'], hrefItem)) {
				el.setAttribute('data-type', 'html5video');
			}
			el.addEventListener('click', function (e) {
				var itemIndex = 0,
						fancybox_name = '',
						list;
				if (el.getAttribute('data-fancybox')) {
					fancybox_name = el.getAttribute('data-fancybox');
					list = document.querySelectorAll('[data-fancybox="' + el.getAttribute('data-fancybox') + '"]');
					for (var i = 0; i < list.length; i++) {
						if (list[i] == el) {
							itemIndex = i;
							break;
						}
					}

					Array.from(document.querySelectorAll('[data-fancybox="' + el.getAttribute('data-fancybox') + '"] model-viewer')).forEach(function (el) {
						el.addEventListener('click', function (e) {
							e.preventDefault();
							e.stopPropagation();
							e.cancelBubble = true;
							return false;
						});
						// loadModelViewer();
					});
				}
				loadRes("//trellisblissindia.com/cdn/shop/t/15/assets/plugin-fancybox.js?v=60790088875158203601792476928", function () {
					new_css('css-fancybox', '//trellisblissindia.com/cdn/shop/t/15/assets/async-fancybox.css?v=57980775351751459211792476869');
					createFancyboxAndShowItem(itemIndex, fancybox_name);
				}, 'fancybox-loaded');
				e.preventDefault();
			});
		});
	}
});
window.dispatchEvent(fancyboxEvt);


var nextUntil = function (elem, selector, filter) {
	"use strict";
	var siblings = [];
	elem = elem.nextElementSibling;
	while (elem) {
		if (elem.matches(selector)) {
			break;
		}
		if (filter && !elem.matches(filter)) {
			elem = elem.nextElementSibling;
			continue;
		}
		siblings.push(elem);
		elem = elem.nextElementSibling;
	}
	return siblings;
};

var table_drop = document.getElementsByClassName('table-drop');
if (table_drop.length) {
	Array.from(table_drop).forEach(function (el) {
		"use strict";
		Array.from(el.getElementsByTagName('tr')).forEach(function (et) {
			if (!et.classList.contains('sub')) {
				et.classList.add('not-sub');
			}
		});
		Array.from(el.querySelectorAll('a.toggle')).forEach(function (em) {
			em.addEventListener('click', function (e) {
				var next = nextUntil(em.closest('tr'), '.not-sub');
				em.classList.toggle('active');
				Array.from(next).forEach(function (en) {
					en.classList.toggle('hidden');
					en.classList.toggle('active');
				});
				e.preventDefault();
			});
		});
	});
}

/*var form_search = document.getElementsByClassName('f8se');
if (form_search.length) {
	Array.from(form_search).forEach(function (el) {
		"use strict";
		if(el.classList.contains('no-js')){
			el.classList.add('hidden');
		}
	});
}*/

var anchor_element = document.querySelectorAll('[id^="section-"]');
if (anchor_element.length) {
	Array.from(anchor_element).forEach(function (el) {
		"use strict";
		var anchor_tag = createElementWithClass('span', 'anchor');
		anchor_tag.setAttribute('id', el.getAttribute('id'));
		el.classList.add('has-anchor');
		el.removeAttribute('id');
		el.append(anchor_tag);
	});
}
//Query( "[attribute^='value']" )

/*var list_product_model = document.querySelectorAll('.l4pr model-viewer');
if (list_product_model.length) {
	loadModelViewer();
}*/

// Toggle accessible nav
// move to custom.js
var a_accessible = document.getElementsByClassName('link-accessible');
if (a_accessible.length) {
	Array.from(a_accessible).forEach(function (el) {
		"use strict";
		el.parentElement.classList.add('has-link-accessible');
		if (el.tagName.toLowerCase() === 'a') {
			el.addEventListener('click', function (e) {
				// console.log("click");
				if (html_tag.classList.contains('t1ac')) {
					html_tag.classList.remove('t1ac');
					Cookies.set('accessible', 'no');
				} else {
					new_css('accessible-mode-css', "//trellisblissindia.com/cdn/shop/t/15/assets/theme-accessible.css?v=19045189261056603801792476942");
					html_tag.classList.add('t1ac');
					//removeDark();
					Cookies.set('accessible', 'yes');
				}
				e.preventDefault();
			});
		}
	});
}
if (general.enable_accessibility_default && Cookies.get('accessible') == undefined) {
	Cookies.set('accessible', 'yes');
}
if (Cookies.get('accessible') === 'yes') {
	new_css('accessible-mode-css', "//trellisblissindia.com/cdn/shop/t/15/assets/theme-accessible.css?v=19045189261056603801792476942");
	html_tag.classList.add('t1ac');
	//removeDark();
} else {
	html_tag.classList.remove('t1ac');
	Cookies.remove('accessible');
}

var shopify_default_css = document.getElementById('shopify-dynamic-checkout');
if (shopify_default_css) {
	shopify_default_css.remove();
}

if (!html_tag.classList.contains('scrolled')) {
	window.addEventListener('resize', function () {
		html_tag.classList.remove('scrolled');
	});
	window.addEventListener('scroll', function () {
		html_tag.classList.add('scrolled');
	});
}


window.addEventListener("lazyloadAgain", function(event) {
	var element = event.details.section;
	var img_lazy = element.querySelectorAll('img[data-src]:not(.dont), picture[data-srcset]:not(.dont)');
	for (var i = 0; i < img_lazy.length; i = i + 1) {
		img_lazy[i].classList.add('lazy');
	}
	yall();
}, false);

// Live search
var liveSearch = function (elem) {
	const searchTerm = elem.value.trim();
	getSearchResults(searchTerm);
}
var getSearchResults = function (searchTerm) {
	var liveSearchEl = document.getElementById('livesearch');
	fetch(routes.predictive_search_url + "?q="+searchTerm+"&resources[type]=product,collection,page,article&section_id=livesearch")
		.then((response) => {
    	if (!response.ok) {
      	var error = new Error(response.status);
        throw error;
      }
      return response.text();
    })
    .then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-livesearch').innerHTML;
			liveSearchEl.innerHTML = resultsMarkup;
			search_id.classList.remove('processing');
      window.dispatchEvent(ratingsEvt);
    })
    .catch((error) => {
      this.close();
      throw error;
    });
};

// Ajax cart
var ajaxCart = (function(module) {
	var init, formOverride, addCartItem, updateCartPanel, showCartPanel, updateItemQty, handleCartUpdates, removeItem, updateCartCount, handleErrorMessage; // Define the functions
	var productFormContainer, sideCartContainer, cartPageTemplate, countElement, formData, formObject, line, quantity, count, config; // Define the data and elements

	init = function () {
		productFormContainer = document.querySelectorAll('form.f8pr:not(.cart-initialized), form.form-card:not(.initialized)');
		cartPageContainer = document.querySelector('form.form-cart, .cart-empty');
		sideCartContainer = document.getElementById('cart');
		countElement = document.getElementById('cart-count');

		if (productFormContainer.length) { formOverride();	} // when there is an product form, initialize the ajax cart for the entire form
		if (cartPageContainer != null) { // when there is an cart form, initialize the ajax cart for the inputs in the form
			cartPageContainer = cartPageContainer.parentElement;
			cartPageTemplate = cartPageContainer.id.replace('shopify-section-', '');
			handleCartUpdates(cartPageContainer);
		}
	};

	formOverride = function () {
		Array.from(productFormContainer).forEach(function (form) {
			form.classList.add('cart-initialized');
			form.addEventListener('submit', function (e) {
				new_css('form-validation-css', "//trellisblissindia.com/cdn/shop/t/15/assets/async-validation.css?v=59164697892790304421792476874");
				form.classList.add('processing');
				e.preventDefault();
				addCartItem(form);
			});
		});
	};

	addCartItem = function(form) {
		formData = new FormData(form);
		if (general.template == 'cart') {
			formData.append('sections', 'side-cart,' + cartPageTemplate);
		} else {
			formData.append('sections', 'side-cart');
		}
		config = {
			method: 'POST',
			body: formData,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Accept': 'application/javascript'
			}
		};
		fetch(routes.cart_add_url, config)
			.then((response) => response.json())
			.then((response) => {
				form.classList.remove('processing');
				if (response.status) {
					handleErrorMessage(response.description);
					return;
				}
				updateCartPanel(response);
				if (general.template == 'cart') {
					updateCartPage(response);
				}
			})
			.catch((error) => {
				console.log("addCartItem error", error);
			});
	}

	handleErrorMessage = function(errorMessage = false) {
		if (errorMessage) {
			var alertAttributes = { message: errorMessage, type: "error" },
					showAlertEvent = new CustomEvent("showAlert", {detail: alertAttributes});
			window.dispatchEvent(showAlertEvent);
		}
	}

	showCartPanel = function() {
		document.querySelector('a[data-panel="cart"]').click();
	}

	updateCartPage = function(response = false) {
		if (response) {
			const resultsMarkup = new DOMParser().parseFromString(response.sections[cartPageTemplate], 'text/html').querySelector("#shopify-section-" + cartPageTemplate).innerHTML;
			handleCartPage(resultsMarkup);
		}
	}

	updateCartPanel = function(response = false, openCartPanel = true) {
		if (response) {
			const resultsMarkup = new DOMParser().parseFromString(response.sections["side-cart"], 'text/html').querySelector('#shopify-section-side-cart').innerHTML;
			handleCartPanel(resultsMarkup, openCartPanel);
		} else if (sideCartContainer.childNodes.length < 2){
			fetch("/?section_id=side-cart")
				.then((response) => {
					if (!response.ok) {
						var error = new Error(response.status);
						throw error;
					}
					return response.text();
				})
				.then((text) => {
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-side-cart').innerHTML;
					handleCartPanel(resultsMarkup, openCartPanel);
				})
				.catch((error) => {
					console.log("updateCartPanel error", error);
					throw error;
				});
		}
	}

	handleCartPage = function(resultsMarkup) {
		cartPageContainer.innerHTML = resultsMarkup;
		window.dispatchEvent(semanticInputEvt);
		window.dispatchEvent(accordeonEvt);
		window.dispatchEvent(countdownEvt);
		handleCartUpdates(cartPageContainer);
		updateCartCount();
	}

	handleCartPanel = function(resultsMarkup, openCartPanel) {
		sideCartContainer.innerHTML = resultsMarkup;
		window.dispatchEvent(modulePanelEvt);
		window.dispatchEvent(semanticInputEvt);
		handleCartUpdates(sideCartContainer);
		updateCartCount();
		if (openCartPanel) { showCartPanel(); }
	}

	handleCartUpdates = function(container) {
		var updateItemInput = container.querySelectorAll('input[name="updates[]"]'),
				removeItemLink 	= container.getElementsByClassName('remove-from-cart-link');

		Array.from(updateItemInput).forEach(function (input) {
			input.addEventListener('change', function (e) {
				updateItemQty(e.target, container);
			});
		});

		Array.from(removeItemLink).forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				removeItem(e.target, container);
			});
		});
	}

	updateItemQty = function(input, container) {
		line = parseInt(input.dataset.line),
		quantity = parseInt(input.value);
		config = {
			method: 'POST',
			body: JSON.stringify({
					'line': line,
					'quantity': quantity,
					'sections': 'side-cart,'+ cartPageTemplate
				}),
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json',
				'Accept': 'application/javascript'
			}
		};
		fetch(routes.cart_change_url, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					handleErrorMessage(response.description);
					return;
				}
				if (container === sideCartContainer) {
					updateCartPanel(response);
				}
				if (cartPageContainer != null ) {
					updateCartPage(response);
					updateCartPanel(response, false);
				}
			})
			.catch((error) => {
				console.log("updateItemQty error", error);
			});
	};

	removeItem = function(link, container) {
		config = {
			method: 'POST',
			body: JSON.stringify({
					'sections': 'side-cart,' + cartPageTemplate
				}),
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json',
				'Accept': 'application/javascript'
			}
		};
		fetch(link.href, config)
		.then((response) => response.json())
		.then((response) => {
			if (response.status) {
				handleErrorMessage(response.description);
				return;
			}
			if (container === sideCartContainer) {
				updateCartPanel(response);
			}
			if (cartPageContainer != null ) {
				updateCartPage(response);
				updateCartPanel(response, false);
			}
		})
		.catch((error) => {
			console.log("removeItem error", error);
		});
	};

	updateCartCount = function(resultsMarkup) {
		count = document.querySelector('[data-totalqty]').dataset.totalqty;
		countElement.innerHTML = count;
	}

	module = {
			init: init,
			load: updateCartPanel
	};
	return module;

}(ajaxCart || {}));
ajaxCart.init();

// Currency/country/language selector
var localization_form = document.querySelectorAll('.localization-form a');
Array.from(localization_form).forEach(function (el) {
	el.addEventListener("click", function(event) {
		event.preventDefault();
		var form = el.closest('form'),
				input = form.querySelector('input[name="locale_code"], input[name="country_code"]');
		input.value = el.dataset.value;
		form.submit();
	})
})

// Collectionpage: sort_by
window.addEventListener("collectionSort", function (evt) {
	var sort_by = document.getElementById('sort_by'),
			sort_by_clone = document.getElementsByClassName('sort_by_clone')[0];
	if (sort_by != null) {
		Shopify.queryParams = {};
		if (location.search.length) {
			for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
				aKeyValue = aCouples[i].split('=');
				if (aKeyValue.length > 1) {
					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
				}
			}
		}
		sort_by.addEventListener('change', function() {
			var el = this;
			if (sort_by_clone != null) { sort_by_clone.value == el.value; }
			setTimeout(function () {
				Shopify.queryParams.sort_by = el.value;
				url = Object.keys(Shopify.queryParams).map(function(k) {
							return encodeURIComponent(k) + '=' + encodeURIComponent(Shopify.queryParams[k])
				}).join('&');
				location.search = url;
			},1);
		});
	}
});
window.dispatchEvent(collectionSortEvt);

// Grid or list view
var saveCollectionview = function(view) {
	config = {
		method: 'POST',
		body: JSON.stringify({
				attributes: {
					'collection_view': view
				}
		}),
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json',
			'Accept': 'application/javascript'
		}
	};
	fetch(routes.cart_update_url, config)
		.then((response) => response.json())
		.then((response) => {
			if (response.status) {
				handleErrorMessage(response.description);
				return;
			}
		})
		.catch((error) => {
			console.log("saveCollectionview error", error);
		});
}

var clearRangeInputs = function(minInput, maxInput) {
	var minInput = document.querySelector('#filter input#min'),
			maxInput = document.querySelector('#filter input#max');
	// minInput.value = minInput.getAttribute('min');
	// maxInput.value = maxInput.getAttribute('max');
	if (minInput && maxInput) {
		minInput.removeAttribute('name');
		maxInput.removeAttribute('name');
	}
}
var clearAllInputs = function() {
	clearRangeInputs();
	var inputs = document.querySelectorAll('#filter input[type="checkbox"]:checked');
	Array.from(inputs).forEach(function (el) {
		el.checked = false;
	});
}

window.addEventListener("initFilters", function (evt) {
	if (document.getElementById('filter') != null) {
		new_css('form-validation-css', "//trellisblissindia.com/cdn/shop/t/15/assets/async-validation.css?v=59164697892790304421792476874");
		filter_form = document.getElementById('filter');
		var form_filter_input_anchors = filter_form.querySelectorAll('li label a');
		Array.from(form_filter_input_anchors).forEach(function (el) {
			el.classList.add('no-click');
		});
		var form_filter_clear = filter_form.querySelectorAll('a.remove-all, a.clear-range');
		if (form_filter_clear.length) {
			Array.from(form_filter_clear).forEach(function (el) {
				el.addEventListener('click', function(e) {
					e.preventDefault();
					if (el.classList.contains('remove-all')) {
						clearAllInputs();
					} else {
						clearRangeInputs();
					}
					processFilters();
				});
			});
		}
		var form_filter_inputs = document.querySelectorAll('#filter input');
		if (form_filter_inputs.length) {
			Array.from(form_filter_inputs).forEach(function (el) {
				el.addEventListener('change', function(event) {
					processFilters();
				});
			});
		}
	}
	// Collectionpage: filters
	var processFilters = function() {
		var filter_form_template = filter_form.dataset.template;
		var collectionSection = document.getElementById('shopify-section-' + filter_form_template);
		filter_form.classList.add('processing');
		if (collectionSection.querySelector('.l4cl')) {
			collectionSection.querySelector('.l4cl').classList.add('processing');
		}
		var minInput = document.querySelector('#filter input#min'),
				maxInput = document.querySelector('#filter input#max');
		if ((minInput && maxInput) && minInput.value == minInput.getAttribute('min') && maxInput.value == maxInput.getAttribute('max')) {
			clearRangeInputs();
		}
		var filterFormData = new FormData(document.getElementById('filter'));
		var filterParams = new URLSearchParams(filterFormData).toString();
		const filterUrl = window.location.pathname + '?section_id=' + filter_form_template + '&' + filterParams;
		fetch(filterUrl)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					throw error;
				}
				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + filter_form_template);
				Array.from(filter_form.querySelectorAll('h4[data-filter-toggle].toggle')).forEach(function (el) {
					resultsMarkup.querySelector('h4[data-filter-toggle="'+ el.dataset.filterToggle +'"]').classList.add('toggle');
				});
				collectionSection.innerHTML = resultsMarkup.innerHTML;
				history.pushState({ filterParams }, '', `${window.location.pathname}${filterParams && '?'.concat(filterParams)}`);
				window.dispatchEvent(collectionSortEvt);
				window.dispatchEvent(rangeSliderEvt);
				window.dispatchEvent(gridListSwitchEvt);
				linkMore();
				window.dispatchEvent(initFiltersEvt);
				window.dispatchEvent(mobileFiltersEvt);
				lazyloadAgainEvt.details = { section: collectionSection };
				window.dispatchEvent(lazyloadAgainEvt);
			})
			.catch((error) => {
				console.log("processFilters error", error);
				throw error;
			});
	};
});
window.dispatchEvent(initFiltersEvt);

// Productpage AR functionality
var model3d = document.querySelectorAll('[data-shopify-xr]');
if (model3d.length) {
  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(errors) {
      if (errors) return;
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () =>
          this.setupShopifyXR()
        );
        return;
      }
      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };
	if (window.ProductModel) window.ProductModel.loadShopifyXR();
}

// Productpage variant select
window.addEventListener("productVariants", function (evt) {
	var main_id_input = document.querySelectorAll('[id^="main-product-form"] select[name="id"]:not(.listening), [id^="main-product-form"] input[type="radio"][name="id"]:not(.listening)');
	if (main_id_input.length) {
		new_css('form-validation-css', "//trellisblissindia.com/cdn/shop/t/15/assets/async-validation.css?v=59164697892790304421792476874");
		Array.from(main_id_input).forEach(function (el) {
			el.classList.add('listening');
			el.addEventListener('change', function() {
				setTimeout(function () {
					var selected_variant_id = el.value,
							new_url = el.dataset.url + '?variant=' + selected_variant_id,
							productFormTemplate = el.dataset.template,
							has_dynamic_buy_buttons = false,
						productFormSection = document.querySelector('.m6pr-'+ productFormTemplate);
					productFormSection.querySelector('form').classList.add('processing');
					fetch(new_url + "&sections=" + productFormTemplate)
						.then((response) => {
							if (!response.ok) {
								var error = new Error(response.status);
								throw error;
							}
							return response.text();
						})
						.then((text) => {
							var sections = JSON.parse(text);
							const resultsMarkupForm = new DOMParser().parseFromString(sections[productFormTemplate], 'text/html');

							if (resultsMarkupForm.querySelector('.l4pr .label') != null) { productFormSection.querySelector('.l4pr .label').innerHTML = resultsMarkupForm.querySelector('.l4pr .label').innerHTML; }
							if (resultsMarkupForm.querySelector('.f8ps') != null && productFormSection.querySelector('.f8ps') != null && general.template == 'product' && (productFormSection == document.getElementById('shopify-section-' + productFormTemplate))) { productFormSection.querySelector('.f8ps').innerHTML = resultsMarkupForm.querySelector('.f8ps').innerHTML; }
							if (resultsMarkupForm.querySelector('.overlay-quaternary') != null && productFormSection.querySelector('.overlay-quaternary') != null) {
								has_dynamic_buy_buttons = true;
								existingButtons = productFormSection.querySelector('.overlay-quaternary');
								productFormSection.parentNode.insertBefore(existingButtons, productFormSection.nextSibling);
							}
							if (resultsMarkupForm.getElementsByClassName('no-pl-px') != null) {
								Array.from(resultsMarkupForm.getElementsByClassName('no-pl-px')).forEach(function (el) {
									el.setAttribute('src', el.getAttribute('data-src'));
								});
							}
							productFormSection.querySelector('form').innerHTML = resultsMarkupForm.querySelector('form').innerHTML;
							productFormSection.querySelector('form').classList.remove('processing', 'unavailable');
							if (has_dynamic_buy_buttons) {
								newButtons = productFormSection.querySelector('.overlay-quaternary');
								newButtons.parentNode.insertBefore(existingButtons, newButtons.nextSibling);
								newButtons.remove();
							}
							if (general.template == 'product' && (productFormTemplate.endsWith('main-product')) ) { window.history.replaceState({ }, '', new_url); }
							window.dispatchEvent(productVariantsEvt);
							window.dispatchEvent(productOptionsEvt);
							window.dispatchEvent(semanticSelectEvt);
							window.dispatchEvent(showHideDataElementEvt);
							window.dispatchEvent(sellingplansEvt);
							window.dispatchEvent(pickupAvailabilityEvt);
							window.dispatchEvent(modulePanelEvt);
							window.dispatchEvent(modulePanelAnchorEvt);
							if (resultsMarkupForm.querySelector('.l4pr').dataset.featured_media_position) {
								var swiper = productFormSection.querySelector('.l4pr .swiper-outer').swiper;
								swiper.slideTo((resultsMarkupForm.querySelector('.l4pr').dataset.featured_media_position - 1), 500);
							}
							window.dispatchEvent(semanticInputEvt);
							window.dispatchEvent(formZindexEvt);
							lazyloadAgainEvt.details = { section: productFormSection };
							window.dispatchEvent(lazyloadAgainEvt);
							ajaxCart.init();
						})
						.catch((error) => {
							console.log("Productform variant change error", error);
							throw error;
						});
				},1);
			});
		});
	}
});
window.dispatchEvent(productVariantsEvt);

window.addEventListener("productOptions", function (evt) {
	var options_input = document.querySelectorAll('[id^="main-product-form"] select[name^="options"]:not(.listening), [id^="main-product-form"] input[type="radio"][name^="options"]:not(.listening)');
	if (options_input.length) {
		Array.from(options_input).forEach(function (el) {
			el.classList.add('listening');
			el.addEventListener('change', function() {
				setTimeout(function () {
					var productFormTemplate = el.dataset.template,
						productForm = document.querySelector('.m6pr-'+ productFormTemplate);
					var updateOptions = function() {
						this.options = Array.from(productForm.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"]:checked'), (select) => select.value);
					}
					var getVariantData = function() {
						var data = [];
						Array.from(productForm.querySelectorAll('select[name="id"] option, input[type="radio"][name="id"]')).forEach(function (el) {
							data.push(JSON.parse(el.dataset.options));
						});
						this.variantData = this.variantData || data;
						return this.variantData;
					}
					var updateMasterId = function() {
						this.currentVariant = getVariantData().find((variant) => {
							return !variant.options.map((option, index) => {
								return this.options[index] === option;
							}).includes(false);
						});
					}

					//to do
					var setUnavailable = function() {
						productForm.querySelector('form').classList.add('unavailable');
						productForm.querySelector('form button[type="submit"]').textContent = unavailableText;
						productForm.querySelector('form button[type="submit"]').setAttribute('disabled', 'disabled');
					}
					//to do

					var updateVariantInput = function() {
						if (!this.currentVariant) {
							// toggleAddButton(true, '', true);
							setUnavailable();
						} else {
							const select = productForm.querySelector('select[name="id"]');
							select.value = this.currentVariant.id;
							select.dispatchEvent(changeEvent);
						}
					}
					updateOptions();
					updateMasterId();
					updateVariantInput();
				},1);
			});
		});
	}
});
window.dispatchEvent(productOptionsEvt);

// Productpage selling plans
window.addEventListener("sellingplans", function (evt) {
	var selling_plan_group_input = document.querySelectorAll('input[name="selling_plan_group"]');
	var selling_plan_input = document.querySelectorAll('input[name="selling_plan"]');
	if (selling_plan_group_input.length) {
		Array.from(selling_plan_group_input).forEach(function (el) {
			var productFormTemplate = el.dataset.template,
				productForm = document.querySelector('.m6pr-'+ productFormTemplate);
			el.addEventListener('change', function() {
				if (productForm.querySelector('input[id^="purchase_option_single"][name="selling_plan_group"]:checked') != null) {
					changeSellingPlanRequired(false, el.getAttribute('data-enable'));
				} else {
					changeSellingPlanRequired(true, el.getAttribute('data-enable'));
				}
			});
		});
		var changeSellingPlanRequired = function(addAttribute, container) {
			Array.from(selling_plan_input).forEach(function (el) {
      	el.checked = false;
        el.removeAttribute('required');
				if (addAttribute && (el.closest('[data-element]').getAttribute('data-element') == container)) {
					el.setAttribute('required','required');
				}
			});
		};
	}
});
window.dispatchEvent(sellingplansEvt);

// Productpage pickup availability
window.addEventListener("pickupAvailability", function (evt) {
	var pickup_availability_anchor = document.querySelectorAll('[data-panel="pickup-availability"]');
		if (pickup_availability_anchor.length) {
		Array.from(pickup_availability_anchor).forEach(function (el) {
			el.addEventListener('click', function() {
				var selected_variant_id = el.dataset.id;
				fetch('/variants/'+ selected_variant_id +'/?section_id=pickup-availability')
					.then((response) => {
						if (!response.ok) {
							var error = new Error(response.status);
							throw error;
						}
						return response.text();
					})
					.then((text) => {
						const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('pickup-availability').innerHTML;
						var section = document.getElementById('pickup-availability');
						section.innerHTML = resultsMarkup;
						window.dispatchEvent(modulePanelEvt);
					})
					.catch((error) => {
						console.log("pickupAvailability error", error);
						throw error;
					});
			});
		});
	}
});
window.dispatchEvent(pickupAvailabilityEvt);

// Productpage sticky buy bar
// window.addEventListener("productBuybarBtn", function (evt) {
// 	var form_product_sticky_btn = document.querySelector('.f8ps button');
// 	if (form_product_sticky_btn != null) {
// 		form_product_sticky_btn.addEventListener('click', function() {
// 			document.querySelector('[id^="main-product-form"] button[type="submit"]').click();
// 		});
// 	}
// });
// window.dispatchEvent(productBuybarBtnEvt);

// Productpage recommended products
window.addEventListener("recommendedProducts", function (evt) {
  var product_recommendations = document.querySelector(".product-recommendations");
  if (product_recommendations === null) { return; }
  var product_id = product_recommendations.dataset.productId,
		limit = product_recommendations.dataset.limit,
		template = product_recommendations.dataset.template;
  if (product_id === undefined) {
	  document.getElementById('shopify-section-' + template).classList.remove('hidden');
	  return;
  }
	fetch(routes.product_recommendations_url + '?section_id='+ template +'&limit='+ limit +'&product_id='+ product_id)
		.then((response) => {
			if (!response.ok) {
				var error = new Error(response.status);
				throw error;
			}
			return response.text();
		})
		.then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-' + template + ' .product-recommendations article').innerHTML;
			product_recommendations.querySelector('article').innerHTML = resultsMarkup;
      		if (product_recommendations.querySelector('[data-hide]') != null) { document.getElementById('shopify-section-' + template).innerHTML = ''; return; }
      		document.getElementById('shopify-section-' + template).classList.remove('hidden');
			lazyloadAgainEvt.details = { section: product_recommendations };
			window.dispatchEvent(lazyloadAgainEvt);
			window.dispatchEvent(listCollectionSliderEvt);
			window.dispatchEvent(formZindexEvt);
			window.dispatchEvent(semanticInputEvt);
			window.dispatchEvent(ratingsEvt);
			ajaxCart.init();
		})
		.catch((error) => {
			console.log("recommendedProducts error", error);
			throw error;
		});
});
window.dispatchEvent(recommendedProductsEvt);

// Recently viewed products
window.addEventListener("recentlyViewedProducts", function (evt) {
  var recently_viewed_products = document.getElementsByClassName("recently-viewed-products"),
			currProductData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
	if (general.viewed_product){
		var numberOfProducts = 8,
				productUrl = general.viewed_product,
				productId = general.viewed_product_id,
				productData =  { productUrl: productUrl, productId: productId },
				pushNewProductData = false,
				currProductData, sameProduct, newProductData, sameProductIndex;
		if (currProductData === null) {
			currProductData = [];
			pushNewProductData = true;
		} else {
			sameProduct = currProductData.filter(e => e.productId === productId).length > 0;
			if (sameProduct) {
				sameProductIndex = currProductData.map(function(e) { return e.productId; }).indexOf(productId);
				currProductData.splice(sameProductIndex, 1);
				pushNewProductData = true;
			}
			if (currProductData.length < numberOfProducts && !sameProduct) {
				pushNewProductData = true;
			} else if (currProductData.length >= numberOfProducts && !sameProduct) {
				currProductData.shift();
				pushNewProductData = true;
			}
		}
		if (pushNewProductData) {
			currProductData.push(productData);
			newProductData = JSON.stringify(currProductData);
			localStorage.setItem("recentlyViewedProduct", newProductData);
		}
	}
	if (recently_viewed_products.length) {
	  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
		if (productData == null || !productData.length) {
			Array.from(recently_viewed_products).forEach(function (el) { el.remove(); });
			return;
		}
		var widthClass = 'w20',
				enable_quick_buy_desktop = recently_viewed_products[0].querySelector('[data-enable_quick_buy_desktop]'),
				enable_quick_buy_mobile = recently_viewed_products[0].querySelector('[data-enable_quick_buy_mobile]'),
				enable_quick_buy_qty_selector = recently_viewed_products[0].querySelector('[data-enable_quick_buy_qty_selector]'),
				quick_buy_compact = recently_viewed_products[0].querySelector('[data-enable_quick_buy_compact]'),
				number_of_items = parseInt(recently_viewed_products[0].querySelector('[data-number_of_items]').dataset.number_of_items) || 5,
				max = Math.min(number_of_items, 5);
		switch(max) {
		  case 2:
		    widthClass = 'w50';
		    break;
			case 3:
		    widthClass = 'w33';
		    break;
			case 4:
		    widthClass = 'w25';
		    break;
			case 5:
			default:
				widthClass = 'w20';
		    break;
		}
	  var recentlyViewedHtml = '',
				recentlyViewedProductsObj = {},
				itemsDone = 0,
				data = productData.slice().reverse().slice(0, max);
		Array.from(data).forEach(function (product, index, array) {
			fetch(product.productUrl +'/?section_id=product-item')
				.then((response) => {
					if (!response.ok) {
						var error = new Error(response.status);
						throw error;
					}
					return response.text();
				})
				.then((text) => {
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-product-item').innerHTML;
					recentlyViewedProductsObj[product.productId] = resultsMarkup;
					itemsDone++;
					if (itemsDone === array.length){
						Array.from(data).forEach(function (product) {
							if (recentlyViewedProductsObj[product.productId]) {
								recentlyViewedHtml += recentlyViewedProductsObj[product.productId];
							}
						});
						Array.from(recently_viewed_products).forEach(function (el, index, array) {
							var list_collection = el.querySelector('.l4cl');
							if (data.length > max) {
								list_collection.classList.add('slider');
							} else {
								list_collection.classList.add('mobile-compact');
							}
							list_collection.classList.add(widthClass);
							list_collection.innerHTML = recentlyViewedHtml;
							if (enable_quick_buy_desktop == null && enable_quick_buy_mobile == null) {
								Array.from(list_collection.querySelectorAll('form, .link-btn')).forEach(function (el) {
									el.remove();
								});
							} else {
								Array.from(list_collection.querySelectorAll('form, .link-btn')).forEach(function (el) {
									if (enable_quick_buy_desktop == null) {
										el.classList.add('mobile-only')
									}
									if (enable_quick_buy_mobile == null) {
										el.classList.add('mobile-hide')
									}
								});
								if (enable_quick_buy_qty_selector == null) {
									Array.from(list_collection.querySelectorAll('.input-amount')).forEach(function (el) {
										el.remove();
									});
								}
								if (quick_buy_compact) {
									Array.from(list_collection.querySelectorAll('form button')).forEach(function (el) {
										el.classList.add('compact');
										el.querySelector('.mobile-hide').remove();
										el.querySelector('.icon-cart').classList.remove('mobile-only');
									});
									Array.from(list_collection.querySelectorAll('.link-btn a')).forEach(function (el) {
										el.textContent = 'Options';
									});
								}
							}
	 						lazyloadAgainEvt.details = { section: el };
	 						window.dispatchEvent(lazyloadAgainEvt);
							window.dispatchEvent(ratingsEvt);
						});
						window.dispatchEvent(listCollectionSliderEvt);
						window.dispatchEvent(formZindexEvt);
						window.dispatchEvent(semanticInputEvt);
						ajaxCart.init();
					}
				})
				.catch((error) => {
					console.log("recentlyViewedProducts error", error);
					throw error;
				});
		});
	}
});
window.dispatchEvent(recentlyViewedProductsEvt);

// Address page
var address_delete_button = document.getElementsByClassName("address-delete-button");
if (address_delete_button.length) {
	Array.from(address_delete_button).forEach(function (el) {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			if (confirm(el.dataset.confirmMessage)) {
				var form = document.createElement("form");
			  form.setAttribute("method", 'post');
			  form.setAttribute("action", el.dataset.target);
				var hiddenField = document.createElement("input");
		    hiddenField.setAttribute("type", "hidden");
		    hiddenField.setAttribute("name", '_method');
		    hiddenField.setAttribute("value", 'delete');
		    form.appendChild(hiddenField);
				document.body.appendChild(form);
			  form.submit();
			  document.body.removeChild(form);
	    }
		});
	});
}

// Product reviews button
var add_review_button = document.getElementsByClassName("spr-summary-actions-newreview");
if (add_review_button.length) {
	Array.from(add_review_button).forEach(function (el) {
		el.addEventListener('click', function (e) {
			Array.from(add_review_button).forEach(function (el) {
					el.remove();
			});
			setTimeout(function () {
				if (document.getElementsByClassName("new-review-form").length > 0) {
					document.getElementsByClassName("new-review-form")[0].scrollIntoView(true);
				}
			}, 10);
		});
	});
}

var checkbox_required = document.getElementsByClassName('checkbox-required');
if (checkbox_required.length) {
	Array.from(checkbox_required).forEach(function (form_el) {
		var inputs = form_el.getElementsByTagName('input');
		Array.from(inputs).forEach(function (input_el) {
			input_el.addEventListener('click', function (e) {
				checkIfChecked(form_el);
			});
		});
	});
	var checkIfChecked = function(form) {
		var checked = form.querySelector('input:checked');
		var inputs = form.getElementsByTagName('input');
		if (!checked) {
			if (inputs[0] != null) {
				inputs[0].setAttribute('required', '');
			}
		} else {
			if (inputs != null) {
				Array.from(inputs).forEach(function (el) {
					el.removeAttribute('required');
				});
			}
		}
	}

}
